// Translation keys for Work+ application
const translations = {
  en: {
    // Common
    'app.name': 'Work+',
    'app.tagline': 'Presence Tracking',
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.filters': 'Filters',
    'common.from': 'From',
    'common.to': 'To',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.create': 'Create',
    'common.search': 'Search',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.export': 'Export',
    'common.refresh': 'Refresh',
    'common.close': 'Close',
    'common.open': 'Open',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.all': 'All',
    'common.none': 'None',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.add': 'Add',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.role': 'Role',
    'common.status': 'Status',
    'common.actions': 'Actions',
    'common.date': 'Date',
    'common.created': 'Created',
    'common.allRoles': 'All Roles',
    'common.employee': 'Employee',
    'common.object': 'Object',
    'common.allEmployees': 'All employees',
    'common.allObjects': 'All objects',
    'common.assigned': 'assigned',
    'common.work': 'Work',
    'common.out': 'Out',
    'common.all': 'All',
    'common.none': 'None',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.import': 'Import',
    'common.template': 'Template',
    'common.download': 'Download',
    'common.upload': 'Upload',
    'common.saveChanges': 'Save Changes',
    'common.update': 'Update',
    'common.type': 'Type',
    'common.configured': 'Configured',
    'common.description': 'Description',
    'common.time': 'Time',
    'common.address': 'Address',
    'common.timezone': 'Timezone',
    'common.noData': 'No data',
    'common.confirmDelete': 'Are you sure you want to delete?',
    'common.rules': 'Rules',
    
    // Dialogs
    'dialog.editEmployee': 'Edit Employee',
    'dialog.bulkImport': 'Bulk Import Employees',
    'dialog.bulkImportDesc': 'Import multiple employees from a CSV file',
    'dialog.downloadTemplate': 'Download CSV Template',
    'dialog.getFormat': 'Get the correct format',
    'dialog.uploadFile': 'Upload CSV File',
    'dialog.pasteCSV': 'Or paste CSV content',
    'dialog.csvFormat': 'CSV Format:',
    'dialog.nameRequired': 'name (required): Employee full name',
    'dialog.emailRequired': 'email (required): Unique email address',
    'dialog.passwordOptional': 'password (optional): Default is "changeme123"',
    'dialog.roleOptional': 'role (optional): admin, hr, controller, or employee',
    'dialog.objectsOptional': 'assigned_objects (optional): Object IDs separated by semicolon',
    'dialog.noObjectsAvailable': 'No objects available',
    'dialog.accountActive': 'Account Active',
    'dialog.notesAbout': 'Notes about employee',
    
    // Objects form
    'objects.bufferZone': 'Buffer Zone (m)',
    'objects.gracePeriod': 'Grace Period (min)',
    'objects.pauseAllowed': 'Pause Allowed',
    'objects.maxTimesHour': 'Max times/hour',
    'objects.maxMinutesShift': 'Max minutes/shift',
    'objects.lunchAllowed': 'Lunch Allowed',
    'objects.lunchMandatory': 'Lunch Mandatory',
    'objects.minDuration': 'Min duration (min)',
    'objects.maxDuration': 'Max duration (min)',
    'objects.shiftSettings': 'Shift Settings',
    'objects.shiftStart': 'Shift Start',
    'objects.shiftEnd': 'Shift End',
    'objects.countEarlyArrival': 'Count early arrival',
    'objects.countOvertime': 'Count overtime',
    'objects.maxOvertime': 'Max overtime (min)',
    'objects.geofenceRadius': 'Geofence radius',
    'objects.noObjectsYet': 'No objects yet',
    'objects.createFirst': 'Create your first work site to start tracking presence',
    
    // Map
    'map.enterAddress': 'Enter address...',
    'map.search': 'Search',
    'map.searching': 'Searching...',
    'map.myLocation': 'My location',
    'map.latitude': 'Latitude',
    'map.longitude': 'Longitude',
    'map.radius': 'Radius (m)',
    'map.clickToSelect': 'Click on the map to select a point',
    'map.addressNotFound': 'Address not found',
    'map.geolocationError': 'Could not get geolocation',
    'map.selectBuilding': 'Select building',
    'map.currentLocation': 'Current location',
    'map.buildingAvailable': 'Building outline',
    'map.useBuildingOutline': 'Use building outline as geofence',
    'map.buildingModeHint': 'Building outline is used as geofence',
    'map.geofenceMode': 'Geofence type',
    'map.circleRadius': 'Circle (radius)',
    'map.buildingOutline': 'Building outline loaded',
    'map.building': 'Building',
    'map.nextBuilding': 'Next building',
    'map.clickBuildingHint': 'Click on any building on the map to select it',
    'map.noBuildingOutline': 'Building outline not available for this address',
    'map.detectBuilding': 'Detect building',
    'map.noBuildingFound': 'No building found at this location',
    'map.modeCircle': 'Circle',
    'map.modeBuilding': 'Building',
    'map.modeDraw': 'Draw zone',
    'map.buildingHint': 'Select a location on the map, then detect the building outline from OpenStreetMap',
    'map.drawHint': 'Click "Start drawing", then click on the map to add points. Minimum 3 points.',
    'map.startDraw': 'Start drawing',
    'map.drawingActive': 'Drawing mode',
    'map.points': 'pts',
    'map.finishDraw': 'Finish zone',
    'map.zoneDrawn': 'Zone ready',
    'map.editPoints': 'Edit points',
    'map.redraw': 'Redraw',
    'map.currentLocation': 'My location',
    'map.enterAddress': 'Enter address...',
    'map.searching': 'Searching...',
    'map.myLocation': 'My location',
    'map.radius': 'Radius',
    'map.clickToSelect': 'Click on the map to set a point',

    // Violations
    'violations.totalInPeriod': 'Total violations in selected period',
    'violations.noViolations': 'No violations found',
    'violations.pauseLimitExceeded': 'Pause Limit Exceeded',
    'violations.lunchDurationExceeded': 'Lunch Duration Exceeded',
    'violations.frequentOutside': 'Frequent Outside',
    'violations.frequentNoGps': 'Frequent No GPS',
    
    // Absences
    'absences.title': 'Absences',
    'absences.subtitle': 'Track employee absences',
    'absences.addAbsence': 'Add Absence',
    'absences.editRecord': 'Edit Record',
    'absences.employee': 'Employee',
    'absences.type': 'Type',
    'absences.absenceType': 'Absence Type',
    'absences.reason': 'Reason',
    'absences.reasonPlaceholder': 'Describe the reason for absence...',
    'absences.modifiedBy': 'Modified By',
    'absences.allEmployees': 'All Employees',
    'absences.selectEmployee': 'Select Employee',
    'absences.noRecords': 'No absence records',
    'absences.excused': 'Excused',
    'absences.unexcused': 'Unexcused',
    'absences.excusedReason': 'Excused Absence',
    'absences.confirmDelete': 'Delete this record?',
    'absences.msg.added': 'Absence added',
    'absences.msg.updated': 'Record updated',
    'absences.msg.deleted': 'Record deleted',
    'absences.type.noShow': 'No Show',
    'absences.type.sick': 'Sick Leave',
    'absences.type.vacation': 'Vacation',
    'absences.type.personal': 'Personal Reasons',
    'absences.type.other': 'Other',
    
    // Messages
    'msg.employeeUpdated': 'Employee updated successfully',
    'msg.employeeDeleted': 'Employee deleted successfully',
    'msg.failedUpdate': 'Failed to update',
    'msg.failedDelete': 'Failed to delete',
    'msg.failedLoad': 'Failed to load data',
    'msg.exportSuccess': 'Export successful',
    'msg.exportError': 'Export failed',
    'msg.importComplete': 'Import complete',
    'msg.importFailed': 'Import failed',
    'msg.noValidData': 'No valid data found',
    'msg.objectCreated': 'Object created successfully',
    'msg.objectUpdated': 'Object updated successfully',
    'msg.objectDeleted': 'Object deleted successfully',
    'msg.error': 'Error occurred',
    'msg.failedLoad': 'Failed to load data',

    // API error translations (backend messages)
    'error.invalidCredentials': 'Incorrect email or password',

    // Password strength
    'password.weak': 'Weak password',
    'password.medium': 'Acceptable',
    'password.good': 'Good password',
    'password.strong': 'Strong password',
    'password.hint': 'at least 8 characters, letters and numbers',
    'error.tooManyAttempts': 'Too many login attempts. Please try again in 10 minutes.',
    'error.accountDisabled': 'Your account has been disabled. Please contact support.',
    'error.companyDisabled': 'Company account is disabled. Please contact support.',
    'error.trialExpired': 'Trial period has expired. Please contact support.',
    'error.tokenExpired': 'Session expired. Please log in again.',
    'error.invalidToken': 'Invalid or expired link.',
    'error.userNotFound': 'User not found.',
    'error.emailInUse': 'This email is already in use.',
    'error.wrongPassword': 'Current password is incorrect.',
    'error.passwordTooShort': 'Password must be at least 8 characters.',
    'error.invalidInvite': 'Invite link is invalid or has expired.',
    'error.inviteExpired': 'Invite link has expired.',
    'error.emailAlreadyRegistered': 'This email is already registered. Please log in.',
    'error.companyEmailTaken': 'A company with this email already exists.',
    'error.adminNameRequired': 'Administrator name is required.',
    'error.companyNameRequired': 'Company name is required.',
    'error.invalidEmail': 'Invalid email address format.',
    'error.maxEmployeesReached': 'Company has reached the maximum number of employees.',
    'error.userEmailExists': 'A user with this email already exists.',
    'error.selfRegNotAvailable': 'Self-registration is not available. Please contact your administrator.',
    'error.nothingToUpdate': 'No changes to save.',
    'error.cannotDeleteSelf': 'You cannot delete your own account.',
    'error.cannotRemoveLastAdmin': 'Cannot remove the last administrator of the company.',
    'error.noCompany': 'No company associated with this account.',
    'error.companyNotFound': 'Company not found.',
    
    // Violation types
    'violations.type.pause_limit_exceeded': 'Pause Limit Exceeded',
    'violations.type.lunch_duration_exceeded': 'Lunch Duration Exceeded',
    'violations.type.frequent_outside': 'Frequent Outside',
    'violations.type.frequent_no_gps': 'Frequent No GPS',
    'violations.type.no_show': 'No Show',
    'violations.type.late_arrival': 'Late Arrival',
    'violations.type.pause_exceeded': 'Pause Exceeded',
    'violations.type.lunch_exceeded': 'Lunch Exceeded',
    
    // Live view
    'live.dataStale': 'Data may be outdated',
    'live.live': 'Live',
    'live.noSignal': 'No signal',
    'live.lastSeen': 'Last seen',
    'live.minsAgo': ' min ago',
    'live.hoursAgo': 'h ago',
    
    // Reports
    'reports.noDataToExport': 'No data to export',
    
    // Employee
    'employee.notificationsEnabled': 'Notifications enabled',
    'employee.notificationsFailed': 'Failed to enable notifications',
    'employee.locationUpdated': 'Location updated',
    
    // Trial & session
    'login.sessionExpired': 'Your session has expired. Please log in again.',
    'trial.daysLeft': 'Trial ends in {n} days. ',
    'trial.expired': 'Your trial has expired. ',
    'trial.contactSupport': 'Contact support to continue.',
    
    // Employees - objects warning
    'employee.noObjectsAssigned': 'No work objects assigned',
    'employee.noObjectsHint': 'Contact your administrator to assign you to a work object. GPS tracking will not work until you are assigned.',
    'employee.gpsBackgroundTip': 'Keep this page open for accurate GPS tracking',
    'employee.gpsBackgroundHint': 'Your browser does not support background GPS. To track your location while the phone is locked: install this app (Add to Home Screen) and keep the screen on while at work.',
    'employee.myObjects': 'My Assigned Objects',
    'employee.here': 'Active',
    'employee.todayWork': "Today's work",
    'employee.todayPause': 'Pauses',
    'employee.todayLunch': 'Lunch',
    'employee.todayHistory': "Today's summary",
    'employee.pastDays': 'Past days',
    'employee.myHistory': 'My history',
    'employee.workingAt': 'Currently working at',
    'employee.currentObject': 'Object',
    'employee.myHistoryTitle': 'My History',
    'employee.selectMonth': 'Select month',
    'employee.noDataForPeriod': 'No data for this period',
    'employee.dayDetail': 'Day details',
    'employee.violations': 'Violations',
    'employee.noViolations': 'No violations',
    'notes.journal': 'Notes journal',
    'notes.showMore': 'Show more',
    'notes.roleEmployee': 'Employee',
    'notes.roleManager': 'Manager',
    'notes.clearAll': 'Clear all',
    'notes.clearAllConfirm': 'Delete all notes? This cannot be undone.',
    'notes.aboutEmployee': 'Notes about',
    'notes.add': 'Add',
    'notes.save': 'Save',
    'notes.cancel': 'Cancel',
    'notes.placeholder': 'Note text...',
    'notes.visibleToEmployee': 'Visible to employee (appears in their journal)',
    'notes.hiddenForManagement': 'Hidden — management only',
    'notes.journalLabel': 'Journal (visible to employee)',
    'notes.hiddenNotes': 'Hidden notes',
    'notes.noEntries': 'No entries yet',
    'notes.imagePreview': 'Image preview',
    'employee.historyEmpty': 'No entries yet',
    'employee.showHistory': 'Show history',
    'employee.hideHistory': 'Hide history',
    'employee.active': 'Active',

    // Employees
    'employees.addEmployee': 'Add Employee',
    'employees.namePlaceholder': 'Full name',
    'employees.newPassword': 'New Password',
    'employees.leaveEmptyPassword': 'Leave empty to keep current',
    'employees.enterPassword': 'Enter password',
    'employees.defaultPasswordHint': 'Default: changeme123',
    'employees.confirmDelete': 'Delete this employee?',
    'employees.msg.updated': 'Employee updated',
    'employees.msg.created': 'Employee created',
    'employees.msg.deleted': 'Employee deleted',
    'employees.msg.emailRequired': 'Email is required',
    'employees.msg.nameRequired': 'Name is required',
    'employees.msg.passwordTooShort': 'Password must be at least 6 characters',
    'employees.msg.passwordWeak': 'Password must be at least 8 characters and contain a letter and a digit',
    'employees.msg.passwordOk': 'Password meets requirements',
    'employees.import.noCsvData': 'Please enter or upload CSV data',
    'employees.import.missingHeaders': 'CSV must have "name" and "email" columns',
    'employees.import.lineError': 'Line {line}: missing name or email',
    'employees.import.formatHint': 'CSV format: name,email,password,role,objects',
    
    // Auth
    'auth.login': 'Sign In',
    'auth.logout': 'Sign Out',
    'auth.register': 'Sign Up',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Confirm Password',
    'auth.name': 'Full Name',
    'auth.welcomeBack': 'Welcome back',
    'auth.createAccount': 'Create an account',
    'auth.enterCredentials': 'Enter your credentials to access your account',
    'auth.noAccount': "Don't have an account?",
    'auth.haveAccount': 'Already have an account?',
    
    // Super Admin
    'superAdmin.title': 'Super Admin',
    'superAdmin.subtitle': 'Platform company management',
    'superAdmin.tabDashboard': 'Dashboard',
    'superAdmin.tabCompanies': 'Companies',
    'superAdmin.tabEmployees': 'Employees',
    'superAdmin.tabAudit': 'Audit',
    'superAdmin.allCompanies': 'All companies',
    'superAdmin.auditWho': 'Who',
    'superAdmin.auditAction': 'Action',
    'superAdmin.auditDetails': 'Details',
    'superAdmin.auditWhen': 'When',
    'superAdmin.noAudit': 'No audit records',
    'superAdmin.records': 'records',
    'superAdmin.confirmRemoveUser': 'This action cannot be undone.',
    'superAdmin.totalCompanies': 'Total Companies',
    'superAdmin.activeCompanies': 'Active',
    'superAdmin.trialCompanies': 'On Trial',
    'superAdmin.totalEmployees': 'Total Employees',
    'superAdmin.searchPlaceholder': 'Search company...',
    'superAdmin.noCompanies': 'No companies',
    'superAdmin.companiesWillAppear': 'Companies will appear after registration',
    'superAdmin.company': 'Company',
    'superAdmin.subscription': 'Subscription',
    'superAdmin.status': 'Status',
    'superAdmin.employees': 'Employees',
    'superAdmin.created': 'Created',
    'superAdmin.actions': 'Actions',
    'superAdmin.subscriptionActive': 'Active',
    'superAdmin.subscriptionTrial': 'Trial',
    'superAdmin.subscriptionPastDue': 'Past Due',
    'superAdmin.subscriptionCanceled': 'Canceled',
    'superAdmin.subscriptionExpired': 'Expired',
    'superAdmin.planTrial': 'Trial',
    'superAdmin.planStarter': 'Starter',
    'superAdmin.planBusiness': 'Business',
    'superAdmin.planEnterprise': 'Enterprise',
    'superAdmin.companyUsers': 'Company Users',
    'superAdmin.employeeLimit': 'Employee Limit',
    'superAdmin.trialEnds': 'Trial Ends',
    'superAdmin.noUsers': 'No users',
    'superAdmin.objects': 'Objects',
    'superAdmin.workHoursThisMonth': 'Work Hours (This Month)',
    'superAdmin.violationsThisMonth': 'Violations (This Month)',
    'superAdmin.viewDetails': 'View Details',
    'superAdmin.activate': 'Activate',
    'superAdmin.deactivate': 'Deactivate',
    'superAdmin.companyActivated': 'Company activated',
    'superAdmin.companyDeactivated': 'Company deactivated',
    'superAdmin.loadError': 'Failed to load companies',
    'superAdmin.accessDenied': 'Access denied. Super Admin role required',
    
    // Super Admin - Extended
    'superAdmin.createCompany': 'Create Company',
    'superAdmin.editCompany': 'Edit Company',
    'superAdmin.deleteCompany': 'Delete Company',
    'superAdmin.confirmDelete': 'Are you sure you want to delete this company? All data will be permanently removed.',
    'superAdmin.companyCreated': 'Company created successfully',
    'superAdmin.companyUpdated': 'Company updated successfully',
    'superAdmin.companyDeleted': 'Company deleted successfully',
    'superAdmin.editSubscription': 'Edit Subscription',
    'superAdmin.subscriptionUpdated': 'Subscription updated successfully',
    'superAdmin.plan': 'Plan',
    'superAdmin.maxEmployees': 'Max Employees',
    'superAdmin.extendTrial': 'Extend Trial',
    'superAdmin.trialDays': 'Trial Days',
    'superAdmin.addUser': 'Add User',
    'superAdmin.removeUser': 'Remove User',
    'superAdmin.resetPassword': 'Reset Password',
    'superAdmin.newPassword': 'New Password',
    'superAdmin.userAdded': 'User added successfully',
    'superAdmin.userRemoved': 'User removed successfully',
    'superAdmin.passwordReset': 'Password reset successfully',
    'superAdmin.confirmRemoveUser': 'Are you sure you want to remove this user?',
    'superAdmin.cannotRemoveLastAdmin': 'Cannot remove the last admin',
    'superAdmin.adminName': 'Admin Name',
    'superAdmin.adminEmail': 'Admin Email',
    'superAdmin.adminPassword': 'Admin Password',
    'superAdmin.selectRole': 'Select Role',
    'superAdmin.userEmail': 'User Email',
    'superAdmin.userName': 'User Name',
    'superAdmin.companyName': 'Company Name',
    'superAdmin.companyEmail': 'Company Email',
    'superAdmin.phone': 'Phone',
    'superAdmin.address': 'Address',
    'superAdmin.adminData': 'Administrator Information',
    
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.liveView': 'Live View',
    'nav.objects': 'Objects',
    'nav.employees': 'Employees',
    'nav.reports': 'Reports',
    'nav.violations': 'Violations',
    'nav.absences': 'Absences',
    'nav.monthClosing': 'Month Closing',
    'nav.schedule': 'Schedule',
    'schedule.allObjects': 'All objects',
    'schedule.templates': 'Templates',
    'schedule.template': 'Template',
    'schedule.selectTemplate': 'Select template…',
    'schedule.startTime': 'Start',
    'schedule.endTime': 'End',
    'schedule.saved': 'Saved',
    'schedule.deleted': 'Deleted',
    'schedule.cleared': 'Cleared',
    'schedule.noShiftsThisWeek': 'No shifts this week',
    'schedule.copiedShifts': 'shifts copied',
    'schedule.created': 'shifts created',
    'schedule.allFilled': 'All weekdays already filled',
    'schedule.confirmClear': 'Delete all shifts for this employee this month?',
    'schedule.copyWeek': 'Copy week',
    'schedule.clearMonth': 'Clear month',
    'schedule.fillWeekdays': 'Fill Mon–Fri',
    'schedule.noEmployees': 'No employees found',
    'schedule.manageTemplates': 'Shift Templates',
    'schedule.newTemplate': 'New template',
    'schedule.templateName': 'Name',
    'schedule.addTemplate': 'Add template',
    'schedule.color': 'Color',
    'schedule.templateSaved': 'Template saved',
    'schedule.templateNameRequired': 'Enter template name',
    'schedule.myShiftToday': 'My shift today',
    'schedule.noShiftToday': 'No shift assigned',
    'schedule.thisWeek': 'This week',
    'nav.mySchedule': 'My Schedule',
    'nav.myObjects': 'My Objects',
    'nav.myHistory': 'My History',
    'nav.myNotes': 'Notes',
    
    // My Objects
    'myObjects.title': 'My Work Sites',
    'myObjects.subtitle': 'Your assigned work locations',
    'myObjects.noObjects': 'You are not assigned to any objects',
    'myObjects.radius': 'Radius',
    'myObjects.drawnZone': 'Custom zone',
    'myObjects.building': 'Building',
    'myObjects.pauseAllowed': 'Pause allowed',
    'myObjects.pauseNotAllowed': 'Pause not allowed',
    'myObjects.lunchAllowed': 'Lunch allowed',
    'myObjects.lunchNotAllowed': 'Lunch not allowed',
    'myObjects.gracePeriod': 'Grace period',
    'myObjects.nextShift': 'Next shift',
    'myObjects.openMap': 'Open in Maps',
    'myObjects.min': 'min',
    
    'schedule.activeObject': 'Active object',
    'schedule.fromSchedule': 'From schedule',
    'schedule.switchObject': 'Switch object',
    'schedule.shiftConflict': 'Shifts overlap',
    'schedule.maxShifts': 'Max 2 shifts per day',
    'schedule.dayOff': 'Day off',
    'schedule.viewFullSchedule': 'View full schedule',
    'audit.from': 'From',
    'audit.to': 'To',
    'nav.audit': 'Audit Log',
    'nav.billing': 'Billing',
    'nav.salaries': 'Salaries',
    'nav.superAdmin': 'Super Admin',
    'nav.settings': 'Settings',
    
    // Statuses
    'status.working': 'Working',
    'status.pause': 'Pause',
    'status.lunch': 'Lunch',
    'status.outside': 'Outside',
    'status.no_gps': 'No GPS',
    'status.onPause': 'On Pause',
    'status.atLunch': 'At Lunch',
    
    // Roles
    'role.admin': 'Admin',
    'role.hr': 'HR',
    'role.controller': 'Controller',
    'role.employee': 'Employee',
    'role.custom': 'Other (enter manually)',
    'role.customPlaceholder': 'Enter position name...',
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Welcome',
    'dashboard.gpsTabWarning': 'GPS is active — keep this tab open for accurate tracking',
    'dashboard.presenceOverview': 'Real-time presence overview',
    'dashboard.yourDashboard': 'Your presence dashboard',
    'dashboard.currentStatus': 'Current Status',
    'dashboard.thisMonth': 'This Month',
    'dashboard.totalWorkingTime': 'Total working time',
    'dashboard.objectsOverview': 'Objects Overview',
    'dashboard.employeesAssigned': 'employees assigned',
    'dashboard.liveObjects': 'Live Objects',
    'dashboard.objects': 'Objects',
    'dashboard.violations': 'Violations',
    
    // Employee actions
    'employee.pause': 'Pause',
    'employee.lunch': 'Lunch',
    'employee.resume': 'Resume Work',
    'employee.gpsRequired': 'Location Access Required',
    'employee.enableGps': 'Enable to track your work time',
    'employee.enableNotifications': 'Enable Notifications',
    'employee.notificationInfo': 'Get alerts for violations',
    'employee.locationGranted': 'Location access granted',
    'employee.locationDenied': 'Location access denied',
    'employee.notificationsEnabled': 'Notifications enabled',
    'employee.notificationsFailed': 'Failed to enable notifications',
    'employee.statusUpdated': 'Status updated',
    'employee.statusUpdateFailed': 'Failed to update status',
    'employee.myNotes': 'My Notes',
    'employee.noNotes': 'No notes',
    'employee.gpsActive': 'GPS Active',
    'employee.gpsOff': 'GPS Off',
    'employee.trackingOn': 'Tracking On',
    'employee.trackingOff': 'Tracking Off',
    'employee.notificationsOn': 'Notifications On',
    'employee.enable': 'Enable',
    'employee.notesFromManagement': 'Notes from management',
    'employee.from': 'From',
    'employee.myNotes': 'My Notes',
    'employee.addNote': 'Add note',
    'employee.noteTextPlaceholder': 'Write a note...',
    'employee.addPhoto': 'Add photo',
    'employee.noteSaved': 'Note saved',
    'employee.noteSaveError': 'Failed to save note',
    'employee.noteDeleted': 'Note deleted',
    'employee.noteDeleteError': 'Failed to delete note',
    'employee.noNotesYet': 'No notes yet. Add your first note.',
    'employee.activeObjects': 'Active Objects',
    'employee.assigned': 'assigned',
    
    // Objects
    'objects.title': 'Objects',
    'objects.subtitle': 'Manage work sites and geofences',
    'objects.addObject': 'Add Object',
    'objects.createObject': 'Create Object',
    'objects.editObject': 'Edit Object',
    'objects.basicInfo': 'Basic Information',
    'objects.geofence': 'Geofence',
    'objects.rules': 'Rules',
    'objects.assignEmployees': 'Assign Employees',
    'objects.tab_basic': 'Basic',
    'objects.tab_geofence': 'Geofence',
    'objects.tab_rules': 'Rules',
    'objects.tab_employees': 'Employees',
    'objects.type': 'Type',
    'objects.type.permanent': 'Permanent',
    'objects.type.temporary': 'Temporary',
    'objects.permanentType': 'Permanent',
    'objects.temporaryType': 'Temporary',
    'objects.addressPlaceholder': 'Enter address',
    'objects.searchAddress': 'Search',
    'objects.noObjects': 'No objects. Create your first one!',
    'objects.noObjectsAdmin': 'No objects. Create objects to see data.',
    'objects.employees': 'employees',
    
    // Employees
    'employees.title': 'Employees',
    'employees.subtitle': 'Manage employee accounts and assignments',
    'employees.bulkImport': 'Bulk Import',
    'employees.editEmployee': 'Edit Employee',
    'employees.assignedObjects': 'Assigned Objects',
    'employees.objectsOnlyForEmployees': 'Objects can only be assigned to employees',
    'employees.searchPlaceholder': 'Search by name or email...',
    
    // Reports
    'reports.title': 'Reports',
    'reports.subtitle': 'Generate and export presence reports',
    'reports.generate': 'Generate',
    'reports.exportReport': 'Export report',
    'reports.exportTimesheetCSV': 'Export timesheet CSV',
    'reports.exportTimesheetExcel': 'Export timesheet Excel',
    'reports.documentLanguage': 'Document language',
    'reports.startDate': 'Start Date',
    'reports.endDate': 'End Date',
    'reports.noData': 'No data. Use filters and click Generate.',
    'reports.filters': 'Filters',
    'reports.working': 'Working',
    'reports.noGps': 'No GPS',
    
    // Violations
    'violations.title': 'Violations',
    'violations.subtitle': 'Monitor and review rule violations',
    'violations.yourHistory': 'Your violation history',
    'violations.totalViolations': 'Total violations in selected period',
    
    // Month Closing
    'months.title': 'Month Closing',
    'months.subtitle': 'Lock months to make data read-only',
    'months.closeMonth': 'Close Month',
    'months.reopen': 'Reopen',
    'months.closed': 'Closed',
    'months.open': 'Open',
    
    // Billing
    'billing.title': 'Billing',
    'billing.subtitle': 'View billing details and active employees',
    'billing.activeEmployees': 'Active Employees',
    'billing.billingTier': 'Billing Tier',
    'billing.estimatedCost': 'Estimated Cost',
    
    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Configure object rules and preferences',
    'settings.profile': 'Profile',
    'settings.security': 'Security',
    'settings.tabProfile': 'Profile',
    'settings.tabSecurity': 'Security',
    'settings.tabObjects': 'Object Rules',
    'settings.changePassword': 'Change Password',
    'settings.currentPassword': 'Current password',
    'settings.newPassword': 'New password',
    'settings.confirmPassword': 'Confirm password',
    'settings.passwordHint': 'Minimum 8 characters, letters and numbers',
    'settings.passwordMismatch': 'Passwords do not match',
    'settings.passwordTooShort': 'Password must be at least 8 characters',
    'settings.passwordWeak': 'Password must contain letters and numbers',
    'settings.passwordChanged': 'Password changed successfully',
    'settings.wrongOldPassword': 'Wrong current password',
    'settings.profileSaved': 'Profile saved',
    'settings.gracePeriod': 'Grace Period',
    'settings.pauseRules': 'Pause Rules',
    'settings.lunchRules': 'Lunch Rules',
    'settings.pauseAllowed': 'Pause Allowed',
    'settings.lunchAllowed': 'Lunch Allowed',
    'settings.lunchMandatory': 'Lunch Mandatory',
    
    // Audit
    'audit.title': 'Audit Log',
    'audit.subtitle': 'Track all system changes and actions',
    'audit.filters': 'Filters',
    'audit.actionType': 'Action Type',
    'audit.targetType': 'Target Type',
    'audit.allActions': 'All Actions',
    'audit.allTargets': 'All Targets',
    'audit.timestamp': 'Timestamp',
    'audit.user': 'User',
    'audit.action': 'Action',
    'audit.target': 'Target',
    'audit.details': 'Details',
    'audit.noLogs': 'No audit logs found',
    'audit.userCreated': 'User Created',
    'audit.userUpdated': 'User Updated',
    'audit.userDeleted': 'User Deleted',
    'audit.objectCreated': 'Object Created',
    'audit.objectUpdated': 'Object Updated',
    'audit.objectDeleted': 'Object Deleted',
    'audit.geofenceUpdated': 'Geofence Updated',
    'audit.rulesUpdated': 'Rules Updated',
    'audit.monthClosed': 'Month Closed',
    'audit.monthReopened': 'Month Reopened',
    'audit.roleChanged': 'Role Changed',
    'audit.absenceMarked': 'Absence Marked',
    
    // Live View
    'live.title': 'Live View',
    'live.subtitle': 'Real-time employee status monitoring',
    'live.selectObject': 'Select object',
    'live.refresh': 'Refresh',
    'live.working': 'Working',
    'live.onPause': 'On Pause',
    'live.atLunch': 'At Lunch',
    'live.outside': 'Outside',
    'live.noGps': 'No GPS',
    'live.violations': 'Violations',
    'live.employeesAt': 'Employees at',
    'live.lastUpdated': 'Last updated',
    'live.liveIndicator': 'Live',
    'live.noEmployees': 'No employees assigned to this object',
    
    // Month Closing additional
    'months.january': 'January',
    'months.february': 'February',
    'months.march': 'March',
    'months.april': 'April',
    'months.may': 'May',
    'months.june': 'June',
    'months.july': 'July',
    'months.august': 'August',
    'months.september': 'September',
    'months.october': 'October',
    'months.november': 'November',
    'months.december': 'December',
    'months.closedAt': 'Closed',
    'months.aboutTitle': 'About Month Closing',
    'months.aboutItem1': 'Closing a month makes all time entries for that month read-only',
    'months.aboutItem2': 'Employees cannot update their status for dates in a closed month',
    'months.aboutItem3': 'Only Admins can reopen a closed month',
    'months.aboutItem4': 'All close/reopen actions are logged in the audit trail',
    'months.confirmReopen': 'Are you sure you want to reopen {month} {year}? This action will be logged.',
    'months.closeSuccess': '{month} {year} closed successfully',
    'months.reopenSuccess': '{month} {year} reopened successfully',
    'months.closeError': 'Failed to close month',
    'months.reopenError': 'Failed to reopen month',
    'months.loadError': 'Failed to load month status',
    
    // Login page
    'login.presenceBased': 'Presence-Based',
    'login.timeTracking': 'Time Tracking',
    'login.heroDescription': 'Track employee presence at work sites with precision. No routes, no surveillance — just facts.',
    'login.accuracy': 'Accuracy',
    'login.monitoring': 'Monitoring',
    'login.setup': 'Setup',
    'login.welcomeBack': 'Welcome back',
    'login.enterCredentials': 'Enter your credentials to continue',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.signIn': 'Sign In',
    'login.noAccount': 'No account?',
    'login.registerCompany': 'Register company',
    'login.loginFailed': 'Login failed. Please try again.',
    'login.demoHint': 'Demo',
    'login.forgotPassword': 'Forgot password?',
    'acceptInvite.title': 'Set Your Password',
    'acceptInvite.subtitle': 'Create a password to activate your Work+ account',
    'acceptInvite.submit': 'Activate Account',
    'acceptInvite.invalidTitle': 'Link expired or invalid',
    'acceptInvite.invalidBody': 'Please contact your administrator to resend the invitation.',
    'acceptInvite.doneTitle': 'Account activated!',
    'acceptInvite.doneBody': 'Redirecting to login...',
    'acceptInvite.error': 'Something went wrong. Try again.',
    'employees.inviteSent': 'Invitation sent to employee email',
    'forgotPassword.title': 'Forgot Password',
    'forgotPassword.subtitle': "Enter your email and we'll send you a reset link",
    'forgotPassword.send': 'Send Reset Link',
    'forgotPassword.sentTitle': 'Check your email',
    'forgotPassword.sentBody': 'If this email is registered, you will receive a reset link shortly.',
    'forgotPassword.backToLogin': 'Back to login',
    'forgotPassword.error': 'Something went wrong. Try again.',
    'resetPassword.title': 'Set New Password',
    'resetPassword.submit': 'Set New Password',
    'resetPassword.invalidTitle': 'Link expired or invalid',
    'resetPassword.invalidBody': 'Please request a new password reset link.',
    'resetPassword.doneTitle': 'Password changed!',
    'resetPassword.doneBody': 'Redirecting to login...',
    'resetPassword.error': 'Something went wrong. Try again.',
    
    // Register page
    'register.joinToday': 'Join {appName} Today',
    'register.heroDescription': 'Start tracking presence at your work sites. Simple, transparent, and effective.',
    'register.createAccount': 'Create an account',
    'register.enterDetails': 'Enter your details to get started',
    'register.fullName': 'Full Name',
    'register.email': 'Email',
    'register.password': 'Password',
    'register.confirmPassword': 'Confirm Password',
    'register.createAccountBtn': 'Create Account',
    'register.haveAccount': 'Already have an account?',
    'register.signIn': 'Sign in',
    'register.passwordsNoMatch': 'Passwords do not match',
    'register.passwordTooShort': 'Password must be at least 6 characters',
    'register.registerFailed': 'Registration failed. Please try again.',
    
    // Register Company page
    'registerCompany.title': 'Register your company',
    'registerCompany.freeTrial': '30 days free',
    'registerCompany.companyData': 'Company Information',
    'registerCompany.companyName': 'Company Name',
    'registerCompany.companyNamePlaceholder': 'Company name',
    'registerCompany.companyEmail': 'Company Email',
    'registerCompany.phone': 'Phone',
    'registerCompany.phonePlaceholder': '+372 ...',
    'registerCompany.address': 'Address',
    'registerCompany.addressPlaceholder': 'Tallinn',
    'registerCompany.adminData': 'Administrator Information',
    'registerCompany.adminName': 'Your Name',
    'registerCompany.adminNamePlaceholder': 'John Smith',
    'registerCompany.adminEmail': 'Admin Login Email',
    'registerCompany.sameAsCompany': 'Same as company email',
    'registerCompany.password': 'Password',
    'registerCompany.createAccount': 'Create Company Account',
    'registerCompany.haveAccount': 'Already have an account?',
    'registerCompany.signIn': 'Sign In',
    'registerCompany.trialInfo': '30 days free • up to 10 employees • all features',
    'registerCompany.registrationFailed': 'Registration failed',
    'registerCompany.pwMin8': 'At least 8 characters',
    'registerCompany.pwLetter': 'At least one letter',
    'registerCompany.pwDigit': 'At least one digit',
    'registerCompany.pwInvalid': 'Password must be at least 8 characters and contain a letter and a digit',
    'registerCompany.agreeTerms': 'I have read and agree to the',
    'registerCompany.termsLink': 'Terms of Service',
    'registerCompany.agreePrivacy': 'I have read and agree to the',
    'registerCompany.privacyLink': 'Privacy Policy',
    'registerCompany.consentRequired': 'Please agree to the Terms of Service and Privacy Policy to continue',
    
    // Billing page
    'billing.title': 'Subscription',
    'billing.subtitle': 'Manage your company subscription plan',
    'billing.currentPlan': 'Current Plan',
    'billing.trialPeriod': 'Trial Period',
    'billing.expires': 'Expires',
    'billing.active': 'Active',
    'billing.employeeLimit': 'Employee Limit',
    'billing.trialWarning': 'Your trial period will end soon. Choose a plan to continue.',
    'billing.checkingPayment': 'Checking payment status...',
    'billing.paymentSuccess': 'Payment successful! Subscription activated.',
    'billing.sessionExpired': 'Payment session expired. Please try again.',
    'billing.checkEmail': 'Check your email for payment confirmation.',
    'billing.checkoutError': 'Failed to create payment session',
    'billing.perMonth': '/month',
    'billing.upToEmployees': 'Up to {count} employees',
    'billing.allFeatures': 'All features',
    'billing.emailSupport': 'Email support',
    'billing.prioritySupport': 'Priority support',
    'billing.select': 'Select',
    'billing.currentPlanBadge': 'Current',
    'billing.currentPlanBtn': 'Current Plan',
    'billing.securePayment': 'Secure payment via Stripe. Cancel anytime.',
    
    // Salaries page
    'salaries.title': 'Salaries',
    'salaries.subtitle': 'Employee salary management and calculation',
    'salaries.calculate': 'Calculate',
    'salaries.selectEmployee': 'Select Employee',
    'salaries.selectPeriod': 'Select Period',
    'salaries.noConfig': 'No salary configuration for this employee',
    'salaries.notConfigured': 'Not configured',
    'salaries.setupSalary': 'Setup Salary',
    'salaries.salaryType': 'Salary Type',
    'salaries.hourly': 'Hourly',
    'salaries.daily': 'Daily',
    'salaries.monthly': 'Monthly',
    'salaries.baseAmount': 'Base Amount',
    'salaries.currency': 'Currency',
    'salaries.overtimeMultiplier': 'Overtime Multiplier',
    'salaries.nightBonus': 'Night Shift Bonus',
    'salaries.weekendBonus': 'Weekend Bonus',
    'salaries.regularHours': 'Regular Hours',
    'salaries.overtimeHours': 'Overtime Hours',
    'salaries.nightHours': 'Night Hours',
    'salaries.weekendHours': 'Weekend Hours',
    'salaries.basePay': 'Base Pay',
    'salaries.overtimePay': 'Overtime Pay',
    'salaries.nightBonusPay': 'Night Bonus',
    'salaries.weekendBonusPay': 'Weekend Bonus',
    'salaries.totalGross': 'Total Gross',
    'salaries.period': 'Period',
    'salaries.configSaved': 'Salary configuration saved',
    'salaries.configError': 'Failed to save salary configuration',
    'salaries.calcError': 'Failed to calculate salary',
    
    // Settings page
    'settings.title': 'Settings',
    'settings.subtitle': 'Company settings and configuration',
    'settings.companyInfo': 'Company Information',
    'settings.companyName': 'Company Name',
    'settings.companyEmail': 'Company Email',
    'settings.phone': 'Phone',
    'settings.address': 'Address',
    'settings.subscriptionInfo': 'Subscription Information',
    'settings.plan': 'Plan',
    'settings.status': 'Status',
    'settings.employees': 'Employees',
    'settings.trialEnds': 'Trial Ends',
    'settings.notifications': 'Notifications',
    'settings.notificationsDesc': 'Configure how you receive notifications',
    'settings.emailNotifications': 'Email Notifications',
    'settings.pushNotifications': 'Push Notifications',
    'settings.violationAlerts': 'Violation Alerts',
    'settings.saveSuccess': 'Settings saved successfully',
    'settings.saveError': 'Failed to save settings',
  },
  
  ru: {
    // Common
    'app.name': 'Work+',
    'app.tagline': 'Учёт присутствия',
    'common.loading': 'Загрузка...',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.filters': 'Фильтры',
    'common.from': 'От',
    'common.to': 'До',
    'common.delete': 'Удалить',
    'common.edit': 'Изменить',
    'common.create': 'Создать',
    'common.search': 'Поиск',
    'common.filter': 'Фильтр',
    'common.export': 'Экспорт',
    'common.refresh': 'Обновить',
    'common.close': 'Закрыть',
    'common.open': 'Открыть',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'common.all': 'Все',
    'common.none': 'Нет',
    'common.active': 'Активен',
    'common.inactive': 'Неактивен',
    'common.add': 'Добавить',
    'common.name': 'Имя',
    'common.email': 'Email',
    'common.password': 'Пароль',
    'common.role': 'Роль',
    'common.status': 'Статус',
    'common.actions': 'Действия',
    'common.date': 'Дата',
    'common.created': 'Создано',
    'common.allRoles': 'Все роли',
    'common.employee': 'Сотрудник',
    'common.object': 'Объект',
    'common.allEmployees': 'Все сотрудники',
    'common.allObjects': 'Все объекты',
    'common.assigned': 'назначено',
    'common.work': 'Работа',
    'common.out': 'Вне',
    'common.all': 'Все',
    'common.none': 'Нет',
    'common.active': 'Активен',
    'common.inactive': 'Неактивен',
    'common.import': 'Импорт',
    'common.template': 'Шаблон',
    'common.download': 'Скачать',
    'common.upload': 'Загрузить',
    'common.saveChanges': 'Сохранить',
    'common.update': 'Обновить',
    'common.type': 'Тип',
    'common.configured': 'Настроено',
    'common.description': 'Описание',
    'common.time': 'Время',
    'common.address': 'Адрес',
    'common.timezone': 'Часовой пояс',
    'common.noData': 'Нет данных',
    'common.confirmDelete': 'Вы уверены, что хотите удалить?',
    'common.rules': 'Правила',
    
    // Dialogs
    'dialog.editEmployee': 'Редактирование сотрудника',
    'dialog.bulkImport': 'Массовый импорт сотрудников',
    'dialog.bulkImportDesc': 'Импорт нескольких сотрудников из CSV файла',
    'dialog.downloadTemplate': 'Скачать шаблон CSV',
    'dialog.getFormat': 'Получить правильный формат',
    'dialog.uploadFile': 'Загрузить CSV файл',
    'dialog.pasteCSV': 'Или вставьте CSV содержимое',
    'dialog.csvFormat': 'Формат CSV:',
    'dialog.nameRequired': 'name (обязательно): Полное имя сотрудника',
    'dialog.emailRequired': 'email (обязательно): Уникальный email',
    'dialog.passwordOptional': 'password (опционально): По умолчанию "changeme123"',
    'dialog.roleOptional': 'role (опционально): admin, hr, controller или employee',
    'dialog.objectsOptional': 'assigned_objects (опционально): ID объектов через точку с запятой',
    'dialog.noObjectsAvailable': 'Нет доступных объектов',
    'dialog.accountActive': 'Аккаунт активен',
    'dialog.notesAbout': 'Заметки о сотруднике',
    
    // Objects form
    'objects.bufferZone': 'Буферная зона (м)',
    'objects.gracePeriod': 'Грейс-период (мин)',
    'objects.pauseAllowed': 'Пауза разрешена',
    'objects.maxTimesHour': 'Макс. раз/час',
    'objects.maxMinutesShift': 'Макс. мин/смена',
    'objects.lunchAllowed': 'Обед разрешён',
    'objects.lunchMandatory': 'Обед обязателен',
    'objects.minDuration': 'Мин. длительность (мин)',
    'objects.maxDuration': 'Макс. длительность (мин)',
    'objects.shiftSettings': 'Настройка смены',
    'objects.shiftStart': 'Начало смены',
    'objects.shiftEnd': 'Конец смены',
    'objects.countEarlyArrival': 'Считать ранний приход',
    'objects.countOvertime': 'Считать переработку',
    'objects.maxOvertime': 'Макс. переработка (мин)',
    'objects.geofenceRadius': 'Радиус геозоны',
    'objects.noObjectsYet': 'Объектов пока нет',
    'objects.createFirst': 'Создайте первый объект для начала отслеживания',
    
    // Map
    'map.enterAddress': 'Введите адрес...',
    'map.search': 'Найти',
    'map.searching': 'Поиск...',
    'map.myLocation': 'Моя геолокация',
    'map.latitude': 'Широта',
    'map.longitude': 'Долгота',
    'map.radius': 'Радиус (м)',
    'map.clickToSelect': 'Кликните на карту чтобы выбрать точку',
    'map.addressNotFound': 'Адрес не найден',
    'map.geolocationError': 'Не удалось получить геолокацию',
    'map.selectBuilding': 'Выберите здание',
    'map.currentLocation': 'Текущее местоположение',
    'map.buildingAvailable': 'Контур здания',
    'map.useBuildingOutline': 'Использовать контур здания как геозону',
    'map.buildingModeHint': 'Контур здания используется как геозона',
    'map.geofenceMode': 'Тип геозоны',
    'map.circleRadius': 'Круг (радиус)',
    'map.buildingOutline': 'Контур здания',
    'map.building': 'Здание',
    'map.nextBuilding': 'Следующее здание',
    'map.clickBuildingHint': 'Кликните на нужное здание на карте чтобы выбрать',
    'map.noBuildingOutline': 'Контур здания недоступен для этого адреса',
    'map.detectBuilding': 'Найти здание',
    'map.noBuildingFound': 'Здание не найдено в этой точке',
    'map.modeCircle': 'Круг',
    'map.modeBuilding': 'Здание',
    'map.modeDraw': 'Нарисовать',
    'map.buildingHint': 'Выберите точку на карте, затем нажмите кнопку для определения контура здания',
    'map.drawHint': 'Нажмите "Начать рисование", затем кликайте на карту чтобы добавить точки. Минимум 3 точки.',
    'map.startDraw': 'Начать рисование',
    'map.drawingActive': 'Режим рисования',
    'map.points': 'т.',
    'map.finishDraw': 'Завершить зону',
    'map.zoneDrawn': 'Зона готова',
    'map.editPoints': 'Редактировать',
    'map.redraw': 'Перерисовать',
    'map.enterAddress': 'Введите адрес...',
    'map.searching': 'Поиск...',
    'map.myLocation': 'Моё место',
    'map.radius': 'Радиус',

    // Violations
    'violations.totalInPeriod': 'Всего нарушений за период',
    'violations.noViolations': 'Нарушений не найдено',
    'violations.pauseLimitExceeded': 'Превышен лимит пауз',
    'violations.lunchDurationExceeded': 'Превышена длительность обеда',
    'violations.frequentOutside': 'Частое покидание зоны',
    'violations.frequentNoGps': 'Частое отсутствие GPS',
    
    // Absences
    'absences.title': 'Прогулы',
    'absences.subtitle': 'Учёт отсутствий сотрудников',
    'absences.addAbsence': 'Добавить прогул',
    'absences.editRecord': 'Редактировать запись',
    'absences.employee': 'Сотрудник',
    'absences.type': 'Тип',
    'absences.absenceType': 'Тип отсутствия',
    'absences.reason': 'Причина',
    'absences.reasonPlaceholder': 'Опишите причину отсутствия...',
    'absences.modifiedBy': 'Изменено',
    'absences.allEmployees': 'Все сотрудники',
    'absences.selectEmployee': 'Выберите сотрудника',
    'absences.noRecords': 'Нет записей о прогулах',
    'absences.excused': 'Уважительная',
    'absences.unexcused': 'Неуважительная',
    'absences.excusedReason': 'Уважительная причина',
    'absences.confirmDelete': 'Удалить эту запись?',
    'absences.msg.added': 'Прогул добавлен',
    'absences.msg.updated': 'Запись обновлена',
    'absences.msg.deleted': 'Запись удалена',
    'absences.type.noShow': 'Не явился',
    'absences.type.sick': 'Болезнь',
    'absences.type.vacation': 'Отпуск',
    'absences.type.personal': 'Личные причины',
    'absences.type.other': 'Другое',
    
    // Messages
    'msg.employeeUpdated': 'Сотрудник обновлён',
    'msg.employeeDeleted': 'Сотрудник удалён',
    'msg.failedUpdate': 'Не удалось обновить',
    'msg.failedDelete': 'Не удалось удалить',
    'msg.failedLoad': 'Не удалось загрузить данные',
    'msg.exportSuccess': 'Экспорт выполнен успешно',
    'msg.exportError': 'Ошибка экспорта',
    'msg.importComplete': 'Импорт завершён',
    'msg.importFailed': 'Импорт не удался',
    'msg.noValidData': 'Нет валидных данных',
    'msg.objectCreated': 'Объект создан',
    'msg.objectUpdated': 'Объект обновлён',
    'msg.objectDeleted': 'Объект удалён',
    'msg.error': 'Произошла ошибка',

    // API error translations (backend messages)
    'error.invalidCredentials': 'Неверный email или пароль',

    // Password strength
    'password.weak': 'Слабый пароль',
    'password.medium': 'Допустимый',
    'password.good': 'Хороший пароль',
    'password.strong': 'Надёжный пароль',
    'password.hint': 'минимум 8 символов, буквы и цифры',
    'error.tooManyAttempts': 'Слишком много попыток входа. Повторите через 10 минут.',
    'error.accountDisabled': 'Ваш аккаунт отключён. Обратитесь в поддержку.',
    'error.companyDisabled': 'Аккаунт компании отключён. Обратитесь в поддержку.',
    'error.trialExpired': 'Пробный период истёк. Обратитесь в поддержку.',
    'error.tokenExpired': 'Сессия истекла. Пожалуйста, войдите снова.',
    'error.invalidToken': 'Ссылка недействительна или устарела.',
    'error.userNotFound': 'Пользователь не найден.',
    'error.emailInUse': 'Этот email уже используется.',
    'error.wrongPassword': 'Текущий пароль неверный.',
    'error.passwordTooShort': 'Пароль должен содержать не менее 8 символов.',
    'error.invalidInvite': 'Ссылка-приглашение недействительна или устарела.',
    'error.inviteExpired': 'Срок действия приглашения истёк.',
    'error.emailAlreadyRegistered': 'Этот email уже зарегистрирован. Пожалуйста, войдите.',
    'error.companyEmailTaken': 'Компания с таким email уже существует.',
    'error.adminNameRequired': 'Необходимо указать имя администратора.',
    'error.companyNameRequired': 'Необходимо указать название компании.',
    'error.invalidEmail': 'Неверный формат email.',
    'error.maxEmployeesReached': 'Компания достигла максимального числа сотрудников.',
    'error.userEmailExists': 'Пользователь с таким email уже существует.',
    'error.selfRegNotAvailable': 'Самостоятельная регистрация недоступна. Обратитесь к администратору.',
    'error.nothingToUpdate': 'Нет изменений для сохранения.',
    'error.cannotDeleteSelf': 'Нельзя удалить собственный аккаунт.',
    'error.cannotRemoveLastAdmin': 'Нельзя удалить последнего администратора компании.',
    'error.noCompany': 'К этому аккаунту не привязана компания.',
    'error.companyNotFound': 'Компания не найдена.',
    'msg.failedLoad': 'Не удалось загрузить данные',
    
    // Типы нарушений
    'violations.type.pause_limit_exceeded': 'Превышение лимита паузы',
    'violations.type.lunch_duration_exceeded': 'Превышение времени обеда',
    'violations.type.frequent_outside': 'Частые выходы из зоны',
    'violations.type.frequent_no_gps': 'Частое отсутствие GPS',
    'violations.type.no_show': 'Неявка',
    'violations.type.late_arrival': 'Опоздание',
    'violations.type.pause_exceeded': 'Превышение паузы',
    'violations.type.lunch_exceeded': 'Превышение обеда',
    
    // Live просмотр
    'live.dataStale': 'Данные могут быть устаревшими',
    'live.live': 'В эфире',
    'live.noSignal': 'Нет сигнала',
    'live.lastSeen': 'Последний раз',
    'live.minsAgo': ' мин назад',
    'live.hoursAgo': 'ч назад',
    
    // Отчёты
    'reports.noDataToExport': 'Нет данных для экспорта',
    
    // Сотрудник
    'employee.notificationsEnabled': 'Уведомления включены',
    'employee.notificationsFailed': 'Не удалось включить уведомления',
    'employee.locationUpdated': 'Местоположение обновлено',
    'login.sessionExpired': 'Ваша сессия истекла. Пожалуйста, войдите снова.',
    'trial.daysLeft': 'Триал заканчивается через {n} дней. ',
    'trial.expired': 'Ваш триал истёк. ',
    'trial.contactSupport': 'Свяжитесь с поддержкой для продолжения.',
    
    // Employee objects warning (RU)
    'employee.noObjectsAssigned': 'Нет назначенных рабочих объектов',
    'employee.noObjectsHint': 'Обратитесь к администратору для назначения вас на рабочий объект. GPS-трекинг не будет работать пока вы не назначены.',
    'employee.gpsBackgroundTip': 'Держите страницу открытой для точного GPS-трекинга',
    'employee.gpsBackgroundHint': 'Ваш браузер не поддерживает GPS в фоне. Чтобы отслеживать местоположение при заблокированном экране: установите приложение (Добавить на главный экран) и не выключайте экран во время работы.',
    'employee.myObjects': 'Мои назначенные объекты',
    'employee.here': 'Активен',
    'employee.todayWork': 'Работа сегодня',
    'employee.todayPause': 'Паузы',
    'employee.todayLunch': 'Обед',
    'employee.todayHistory': 'Итог за сегодня',
    'employee.pastDays': 'Прошлые дни',
    'employee.myHistory': 'Моя история',
    'employee.workingAt': 'Сейчас работаете на',
    'employee.currentObject': 'Объект',
    'employee.myHistoryTitle': 'Моя история',
    'employee.selectMonth': 'Выбрать месяц',
    'employee.noDataForPeriod': 'Нет данных за этот период',
    'employee.dayDetail': 'Детали дня',
    'employee.violations': 'Нарушения',
    'employee.noViolations': 'Нарушений нет',
    'notes.showMore': 'Показать ещё',
    'notes.roleEmployee': 'Сотрудник',
    'notes.roleManager': 'Менеджер',
    'notes.clearAll': 'Очистить всё',
    'notes.clearAllConfirm': 'Удалить все заметки? Действие необратимо.',
    'notes.aboutEmployee': 'Заметки о',
    'notes.add': 'Добавить',
    'notes.save': 'Сохранить',
    'notes.cancel': 'Отмена',
    'notes.placeholder': 'Текст заметки...',
    'notes.visibleToEmployee': 'Видна сотруднику (появится в его журнале)',
    'notes.hiddenForManagement': 'Скрытая — только для менеджмента',
    'notes.journalLabel': 'Журнал (виден сотруднику)',
    'notes.hiddenNotes': 'Скрытые заметки',
    'notes.noEntries': 'Пока нет записей',
    'notes.imagePreview': 'Просмотр изображения',
    'employee.historyEmpty': 'История пуста',
    'employee.showHistory': 'Показать историю',
    'employee.hideHistory': 'Скрыть историю',
    'employee.active': 'Активно',

    // Employees
    'employees.addEmployee': 'Добавить сотрудника',
    'employees.namePlaceholder': 'Полное имя',
    'employees.newPassword': 'Новый пароль',
    'employees.leaveEmptyPassword': 'Оставьте пустым для сохранения текущего',
    'employees.enterPassword': 'Введите пароль',
    'employees.defaultPasswordHint': 'По умолчанию: changeme123',
    'employees.confirmDelete': 'Удалить этого сотрудника?',
    'employees.msg.updated': 'Сотрудник обновлён',
    'employees.msg.created': 'Сотрудник создан',
    'employees.msg.deleted': 'Сотрудник удалён',
    'employees.msg.emailRequired': 'Email обязателен',
    'employees.msg.nameRequired': 'Имя обязательно',
    'employees.msg.passwordTooShort': 'Пароль должен быть минимум 6 символов',
    'employees.msg.passwordWeak': 'Пароль должен содержать минимум 8 символов, букву и цифру',
    'employees.msg.passwordOk': 'Пароль соответствует требованиям',
    'employees.import.noCsvData': 'Введите или загрузите CSV данные',
    'employees.import.missingHeaders': 'CSV должен содержать столбцы "name" и "email"',
    'employees.import.lineError': 'Строка {line}: отсутствует имя или email',
    'employees.import.formatHint': 'Формат CSV: name,email,password,role,objects',
    
    // Auth
    'auth.login': 'Войти',
    'auth.logout': 'Выйти',
    'auth.register': 'Регистрация',
    'auth.email': 'Email',
    'auth.password': 'Пароль',
    'auth.confirmPassword': 'Подтвердите пароль',
    'auth.name': 'Полное имя',
    'auth.welcomeBack': 'С возвращением',
    'auth.createAccount': 'Создать аккаунт',
    'auth.enterCredentials': 'Введите данные для входа в систему',
    'auth.noAccount': 'Нет аккаунта?',
    'auth.haveAccount': 'Уже есть аккаунт?',
    
    // Super Admin
    'superAdmin.title': 'Super Admin',
    'superAdmin.subtitle': 'Управление компаниями платформы',
    'superAdmin.tabDashboard': 'Дашборд',
    'superAdmin.tabCompanies': 'Компании',
    'superAdmin.tabEmployees': 'Сотрудники',
    'superAdmin.tabAudit': 'Аудит',
    'superAdmin.allCompanies': 'Все компании',
    'superAdmin.auditWho': 'Кто',
    'superAdmin.auditAction': 'Действие',
    'superAdmin.auditDetails': 'Детали',
    'superAdmin.auditWhen': 'Когда',
    'superAdmin.noAudit': 'Нет записей аудита',
    'superAdmin.records': 'записей',
    'superAdmin.confirmRemoveUser': 'Это действие нельзя отменить.',
    'superAdmin.totalCompanies': 'Всего компаний',
    'superAdmin.activeCompanies': 'Активных',
    'superAdmin.trialCompanies': 'На пробном',
    'superAdmin.totalEmployees': 'Всего сотрудников',
    'superAdmin.searchPlaceholder': 'Поиск компании...',
    'superAdmin.noCompanies': 'Нет компаний',
    'superAdmin.companiesWillAppear': 'Компании появятся после регистрации',
    'superAdmin.company': 'Компания',
    'superAdmin.subscription': 'Подписка',
    'superAdmin.status': 'Статус',
    'superAdmin.employees': 'Сотрудники',
    'superAdmin.created': 'Создана',
    'superAdmin.actions': 'Действия',
    'superAdmin.subscriptionActive': 'Активна',
    'superAdmin.subscriptionTrial': 'Пробный период',
    'superAdmin.subscriptionPastDue': 'Просрочена',
    'superAdmin.subscriptionCanceled': 'Отменена',
    'superAdmin.subscriptionExpired': 'Истекла',
    'superAdmin.planTrial': 'Пробный',
    'superAdmin.planStarter': 'Starter',
    'superAdmin.planBusiness': 'Business',
    'superAdmin.planEnterprise': 'Enterprise',
    'superAdmin.companyUsers': 'Пользователи компании',
    'superAdmin.employeeLimit': 'Лимит сотрудников',
    'superAdmin.trialEnds': 'Trial до',
    'superAdmin.noUsers': 'Нет пользователей',
    'superAdmin.objects': 'Объекты',
    'superAdmin.workHoursThisMonth': 'Рабочие часы (этот месяц)',
    'superAdmin.violationsThisMonth': 'Нарушения (этот месяц)',
    'superAdmin.viewDetails': 'Подробнее',
    'superAdmin.activate': 'Активировать',
    'superAdmin.deactivate': 'Деактивировать',
    'superAdmin.companyActivated': 'Компания активирована',
    'superAdmin.companyDeactivated': 'Компания деактивирована',
    'superAdmin.loadError': 'Ошибка загрузки компаний',
    'superAdmin.accessDenied': 'Доступ запрещён. Требуется роль Super Admin',
    
    // Super Admin - Extended
    'superAdmin.createCompany': 'Создать компанию',
    'superAdmin.editCompany': 'Редактировать компанию',
    'superAdmin.deleteCompany': 'Удалить компанию',
    'superAdmin.confirmDelete': 'Вы уверены, что хотите удалить эту компанию? Все данные будут удалены безвозвратно.',
    'superAdmin.companyCreated': 'Компания успешно создана',
    'superAdmin.companyUpdated': 'Компания успешно обновлена',
    'superAdmin.companyDeleted': 'Компания успешно удалена',
    'superAdmin.editSubscription': 'Изменить подписку',
    'superAdmin.subscriptionUpdated': 'Подписка успешно обновлена',
    'superAdmin.plan': 'План',
    'superAdmin.maxEmployees': 'Макс. сотрудников',
    'superAdmin.extendTrial': 'Продлить пробный период',
    'superAdmin.trialDays': 'Дней пробного периода',
    'superAdmin.addUser': 'Добавить пользователя',
    'superAdmin.removeUser': 'Удалить пользователя',
    'superAdmin.resetPassword': 'Сбросить пароль',
    'superAdmin.newPassword': 'Новый пароль',
    'superAdmin.userAdded': 'Пользователь успешно добавлен',
    'superAdmin.userRemoved': 'Пользователь успешно удалён',
    'superAdmin.passwordReset': 'Пароль успешно сброшен',
    'superAdmin.confirmRemoveUser': 'Вы уверены, что хотите удалить этого пользователя?',
    'superAdmin.cannotRemoveLastAdmin': 'Невозможно удалить последнего администратора',
    'superAdmin.adminName': 'Имя администратора',
    'superAdmin.adminEmail': 'Email администратора',
    'superAdmin.adminPassword': 'Пароль администратора',
    'superAdmin.selectRole': 'Выберите роль',
    'superAdmin.userEmail': 'Email пользователя',
    'superAdmin.userName': 'Имя пользователя',
    'superAdmin.companyName': 'Название компании',
    'superAdmin.companyEmail': 'Email компании',
    'superAdmin.phone': 'Телефон',
    'superAdmin.address': 'Адрес',
    'superAdmin.adminData': 'Данные администратора',
    
    // Billing page
    'billing.title': 'Подписка',
    'billing.subtitle': 'Управление планом подписки вашей компании',
    'billing.currentPlan': 'Текущий план',
    'billing.trialPeriod': 'Пробный период',
    'billing.expires': 'Истекает',
    'billing.active': 'Активна',
    'billing.employeeLimit': 'Лимит сотрудников',
    'billing.trialWarning': 'Ваш пробный период скоро закончится. Выберите план для продолжения работы.',
    'billing.checkingPayment': 'Проверяем статус оплаты...',
    'billing.paymentSuccess': 'Оплата прошла успешно! Подписка активирована.',
    'billing.sessionExpired': 'Сессия оплаты истекла. Попробуйте снова.',
    'billing.checkEmail': 'Проверьте email для подтверждения оплаты.',
    'billing.checkoutError': 'Не удалось создать сессию оплаты',
    'billing.perMonth': '/месяц',
    'billing.upToEmployees': 'До {count} сотрудников',
    'billing.allFeatures': 'Все функции',
    'billing.emailSupport': 'Поддержка по email',
    'billing.prioritySupport': 'Приоритетная поддержка',
    'billing.select': 'Выбрать',
    'billing.currentPlanBadge': 'Текущий',
    'billing.currentPlanBtn': 'Текущий план',
    'billing.securePayment': 'Безопасная оплата через Stripe. Отмена в любое время.',
    
    // Salaries page
    'salaries.title': 'Зарплаты',
    'salaries.subtitle': 'Управление и расчёт зарплат сотрудников',
    'salaries.calculate': 'Рассчитать',
    'salaries.selectEmployee': 'Выберите сотрудника',
    'salaries.selectPeriod': 'Выберите период',
    'salaries.noConfig': 'Нет конфигурации зарплаты для этого сотрудника',
    'salaries.notConfigured': 'Без настройки',
    'salaries.setupSalary': 'Настроить зарплату',
    'salaries.salaryType': 'Тип зарплаты',
    'salaries.hourly': 'Почасовая',
    'salaries.daily': 'Подённая',
    'salaries.monthly': 'Месячная',
    'salaries.baseAmount': 'Базовая сумма',
    'salaries.currency': 'Валюта',
    'salaries.overtimeMultiplier': 'Множитель сверхурочных',
    'salaries.nightBonus': 'Бонус за ночные',
    'salaries.weekendBonus': 'Бонус за выходные',
    'salaries.regularHours': 'Обычные часы',
    'salaries.overtimeHours': 'Сверхурочные часы',
    'salaries.nightHours': 'Ночные часы',
    'salaries.weekendHours': 'Часы в выходные',
    'salaries.basePay': 'Базовая оплата',
    'salaries.overtimePay': 'Сверхурочные',
    'salaries.nightBonusPay': 'Ночной бонус',
    'salaries.weekendBonusPay': 'Бонус за выходные',
    'salaries.totalGross': 'Итого (брутто)',
    'salaries.period': 'Период',
    'salaries.configSaved': 'Конфигурация зарплаты сохранена',
    'salaries.configError': 'Ошибка сохранения конфигурации',
    'salaries.calcError': 'Ошибка расчёта зарплаты',
    
    // Settings page
    'settings.title': 'Настройки',
    'settings.subtitle': 'Настройки и конфигурация компании',
    'settings.companyInfo': 'Информация о компании',
    'settings.companyName': 'Название компании',
    'settings.companyEmail': 'Email компании',
    'settings.phone': 'Телефон',
    'settings.address': 'Адрес',
    'settings.subscriptionInfo': 'Информация о подписке',
    'settings.plan': 'План',
    'settings.status': 'Статус',
    'settings.employees': 'Сотрудники',
    'settings.trialEnds': 'Trial до',
    'settings.notifications': 'Уведомления',
    'settings.notificationsDesc': 'Настройка способов получения уведомлений',
    'settings.emailNotifications': 'Email уведомления',
    'settings.pushNotifications': 'Push уведомления',
    'settings.violationAlerts': 'Оповещения о нарушениях',
    'settings.saveSuccess': 'Настройки сохранены',
    'settings.saveError': 'Ошибка сохранения настроек',
    
    // Navigation
    'nav.dashboard': 'Главная',
    'nav.liveView': 'Мониторинг',
    'nav.objects': 'Объекты',
    'nav.employees': 'Сотрудники',
    'nav.reports': 'Отчёты',
    'nav.violations': 'Нарушения',
    'nav.absences': 'Прогулы',
    'nav.monthClosing': 'Закрытие месяца',
    'nav.schedule': 'График',
    'schedule.allObjects': 'Все объекты',
    'schedule.templates': 'Шаблоны',
    'schedule.template': 'Шаблон',
    'schedule.selectTemplate': 'Выбрать шаблон…',
    'schedule.startTime': 'Начало',
    'schedule.endTime': 'Конец',
    'schedule.saved': 'Сохранено',
    'schedule.deleted': 'Удалено',
    'schedule.cleared': 'Очищено',
    'schedule.noShiftsThisWeek': 'Смен на этой неделе нет',
    'schedule.copiedShifts': 'смен скопировано',
    'schedule.created': 'смен создано',
    'schedule.allFilled': 'Все будние дни уже заполнены',
    'schedule.confirmClear': 'Удалить все смены сотрудника за этот месяц?',
    'schedule.copyWeek': 'Скопировать неделю',
    'schedule.clearMonth': 'Очистить месяц',
    'schedule.fillWeekdays': 'Заполнить Пн–Пт',
    'schedule.noEmployees': 'Сотрудники не найдены',
    'schedule.manageTemplates': 'Шаблоны смен',
    'schedule.newTemplate': 'Новый шаблон',
    'schedule.templateName': 'Название',
    'schedule.addTemplate': 'Добавить шаблон',
    'schedule.color': 'Цвет',
    'schedule.templateSaved': 'Шаблон сохранён',
    'schedule.templateNameRequired': 'Введите название шаблона',
    'schedule.myShiftToday': 'Моя смена сегодня',
    'schedule.noShiftToday': 'Смена не назначена',
    'schedule.thisWeek': 'Эта неделя',
    'nav.mySchedule': 'Мой график',
    'nav.myObjects': 'Мои объекты',
    'nav.myHistory': 'Моя история',
    'nav.myNotes': 'Заметки',
    
    // My Objects
    'myObjects.title': 'Мои рабочие места',
    'myObjects.subtitle': 'Назначенные рабочие объекты',
    'myObjects.noObjects': 'Вы не назначены ни на один объект',
    'myObjects.radius': 'Радиус',
    'myObjects.drawnZone': 'Нарисованная зона',
    'myObjects.building': 'Здание',
    'myObjects.pauseAllowed': 'Пауза разрешена',
    'myObjects.pauseNotAllowed': 'Пауза запрещена',
    'myObjects.lunchAllowed': 'Обед разрешён',
    'myObjects.lunchNotAllowed': 'Обед запрещён',
    'myObjects.gracePeriod': 'Льготный период',
    'myObjects.nextShift': 'Ближайшая смена',
    'myObjects.openMap': 'Открыть на карте',
    'myObjects.min': 'мин',
    
    'schedule.activeObject': 'Активный объект',
    'schedule.fromSchedule': 'Из графика',
    'schedule.switchObject': 'Сменить объект',
    'schedule.shiftConflict': 'Смены пересекаются',
    'schedule.maxShifts': 'Максимум 2 смены в день',
    'schedule.dayOff': 'Выходной',
    'schedule.viewFullSchedule': 'Весь график',
    'audit.from': 'С',
    'audit.to': 'По',
    'nav.audit': 'Журнал аудита',
    'nav.billing': 'Биллинг',
    'nav.salaries': 'Зарплаты',
    'nav.superAdmin': 'Super Admin',
    'nav.settings': 'Настройки',
    
    // Statuses
    'status.working': 'Работает',
    'status.pause': 'Пауза',
    'status.lunch': 'Обед',
    'status.outside': 'Вне зоны',
    'status.no_gps': 'Нет GPS',
    'status.onPause': 'На паузе',
    'status.atLunch': 'На обеде',
    
    // Roles
    'role.admin': 'Администратор',
    'role.hr': 'HR',
    'role.controller': 'Контролёр',
    'role.employee': 'Сотрудник',
    'role.custom': 'Другое (ввести вручную)',
    'role.customPlaceholder': 'Введите название должности...',
    'dashboard.title': 'Главная',
    'dashboard.welcome': 'Добро пожаловать',
    'dashboard.gpsTabWarning': 'GPS активен — держите эту вкладку открытой для точного отслеживания',
    'dashboard.presenceOverview': 'Обзор присутствия в реальном времени',
    'dashboard.yourDashboard': 'Ваша панель присутствия',
    'dashboard.currentStatus': 'Текущий статус',
    'dashboard.thisMonth': 'Этот месяц',
    'dashboard.totalWorkingTime': 'Общее рабочее время',
    'dashboard.objectsOverview': 'Обзор объектов',
    'dashboard.employeesAssigned': 'сотрудников назначено',
    'dashboard.liveObjects': 'Активные объекты',
    'dashboard.objects': 'Объекты',
    'dashboard.violations': 'Нарушения',
    
    // Employee actions
    'employee.pause': 'Пауза',
    'employee.lunch': 'Обед',
    'employee.resume': 'Продолжить работу',
    'employee.gpsRequired': 'Требуется доступ к геолокации',
    'employee.enableGps': 'Включите для учёта рабочего времени',
    'employee.enableNotifications': 'Включить уведомления',
    'employee.notificationInfo': 'Получайте уведомления о нарушениях',
    'employee.locationGranted': 'Доступ к геолокации разрешён',
    'employee.locationDenied': 'Доступ к геолокации запрещён',
    'employee.notificationsEnabled': 'Уведомления включены',
    'employee.notificationsFailed': 'Не удалось включить уведомления',
    'employee.statusUpdated': 'Статус обновлён',
    'employee.statusUpdateFailed': 'Не удалось обновить статус',
    'employee.myNotes': 'Мои заметки',
    'employee.noNotes': 'Нет заметок',
    'employee.gpsActive': 'GPS Активен',
    'employee.gpsOff': 'GPS Выкл',
    'employee.trackingOn': 'Отслеживание Вкл',
    'employee.trackingOff': 'Отслеживание Выкл',
    'employee.notificationsOn': 'Уведомления Вкл',
    'employee.enable': 'Включить',
    'employee.notesFromManagement': 'Заметки от руководства',
    'employee.from': 'От',
    'employee.myNotes': 'Мои заметки',
    'employee.addNote': 'Добавить заметку',
    'employee.noteTextPlaceholder': 'Написать заметку...',
    'employee.addPhoto': 'Добавить фото',
    'employee.noteSaved': 'Заметка сохранена',
    'employee.noteSaveError': 'Не удалось сохранить заметку',
    'employee.noteDeleted': 'Заметка удалена',
    'employee.noteDeleteError': 'Не удалось удалить заметку',
    'employee.noNotesYet': 'Заметок пока нет. Добавьте первую заметку.',
    'employee.assigned': 'назначено',
    
    // Objects
    'objects.title': 'Объекты',
    'objects.subtitle': 'Управление рабочими площадками и геозонами',
    'objects.addObject': 'Добавить объект',
    'objects.createObject': 'Создать объект',
    'objects.editObject': 'Редактировать объект',
    'objects.basicInfo': 'Основная информация',
    'objects.geofence': 'Геозона',
    'objects.rules': 'Правила',
    'objects.assignEmployees': 'Назначить сотрудников',
    'objects.tab_basic': 'Основное',
    'objects.tab_geofence': 'Геозона',
    'objects.tab_rules': 'Правила',
    'objects.tab_employees': 'Сотрудники',
    'objects.type': 'Тип',
    'objects.type.permanent': 'Постоянный',
    'objects.type.temporary': 'Временный',
    'objects.permanentType': 'Постоянный',
    'objects.temporaryType': 'Временный',
    'objects.addressPlaceholder': 'Введите адрес',
    'objects.searchAddress': 'Найти',
    'objects.noObjects': 'Нет объектов. Создайте первый!',
    'objects.noObjectsAdmin': 'Нет объектов. Создайте объекты для просмотра данных.',
    'objects.employees': 'сотрудников',
    
    // Employees
    'employees.title': 'Сотрудники',
    'employees.subtitle': 'Управление учётными записями и назначениями',
    'employees.bulkImport': 'Массовый импорт',
    'employees.editEmployee': 'Редактировать сотрудника',
    'employees.assignedObjects': 'Назначенные объекты',
    'employees.objectsOnlyForEmployees': 'Объекты можно назначать только сотрудникам',
    'employees.searchPlaceholder': 'Поиск по имени или email...',
    'employees.searchPlaceholder': 'Поиск по имени или email...',
    
    // Reports
    'reports.title': 'Отчёты',
    'reports.subtitle': 'Формирование и экспорт отчётов о присутствии',
    'reports.generate': 'Сформировать',
    'reports.exportReport': 'Экспорт отчёта',
    'reports.exportTimesheetCSV': 'Экспорт табеля CSV',
    'reports.exportTimesheetExcel': 'Экспорт табеля Excel',
    'reports.documentLanguage': 'Язык документа',
    'reports.startDate': 'Дата начала',
    'reports.endDate': 'Дата окончания',
    'reports.noData': 'Нет данных. Выберите фильтры и нажмите Сформировать.',
    'reports.filters': 'Фильтры',
    'reports.working': 'Работа',
    'reports.noGps': 'Нет GPS',
    
    // Violations
    'violations.title': 'Нарушения',
    'violations.subtitle': 'Мониторинг и проверка нарушений',
    'violations.yourHistory': 'История ваших нарушений',
    'violations.totalViolations': 'Всего нарушений за выбранный период',
    
    // Month Closing
    'months.title': 'Закрытие месяца',
    'months.subtitle': 'Блокировка месяцев для защиты данных',
    'months.closeMonth': 'Закрыть месяц',
    'months.reopen': 'Открыть',
    'months.closed': 'Закрыт',
    'months.open': 'Открыт',
    
    // Billing
    'billing.title': 'Биллинг',
    'billing.subtitle': 'Просмотр данных о расчётах и активных сотрудниках',
    'billing.activeEmployees': 'Активные сотрудники',
    'billing.billingTier': 'Тарифный план',
    'billing.estimatedCost': 'Ориентировочная стоимость',
    
    // Settings
    'settings.title': 'Настройки',
    'settings.subtitle': 'Настройка правил для объектов',
    'settings.profile': 'Профиль',
    'settings.security': 'Безопасность',
    'settings.tabProfile': 'Профиль',
    'settings.tabSecurity': 'Безопасность',
    'settings.tabObjects': 'Правила объектов',
    'settings.changePassword': 'Сменить пароль',
    'settings.currentPassword': 'Текущий пароль',
    'settings.newPassword': 'Новый пароль',
    'settings.confirmPassword': 'Подтвердите пароль',
    'settings.passwordHint': 'Минимум 8 символов, буквы и цифры',
    'settings.passwordMismatch': 'Пароли не совпадают',
    'settings.passwordTooShort': 'Пароль должен содержать минимум 8 символов',
    'settings.passwordWeak': 'Пароль должен содержать буквы и цифры',
    'settings.passwordChanged': 'Пароль успешно изменён',
    'settings.wrongOldPassword': 'Неверный текущий пароль',
    'settings.profileSaved': 'Профиль сохранён',
    'settings.gracePeriod': 'Льготный период',
    'settings.pauseRules': 'Правила пауз',
    'settings.lunchRules': 'Правила обеда',
    'settings.pauseAllowed': 'Паузы разрешены',
    'settings.lunchAllowed': 'Обед разрешён',
    'settings.lunchMandatory': 'Обед обязателен',
    
    // Audit
    'audit.title': 'Журнал аудита',
    'audit.subtitle': 'Отслеживание всех изменений в системе',
    'audit.filters': 'Фильтры',
    'audit.actionType': 'Тип действия',
    'audit.targetType': 'Тип объекта',
    'audit.allActions': 'Все действия',
    'audit.allTargets': 'Все объекты',
    'audit.timestamp': 'Время',
    'audit.user': 'Пользователь',
    'audit.action': 'Действие',
    'audit.target': 'Объект',
    'audit.details': 'Детали',
    'audit.noLogs': 'Записи аудита не найдены',
    'audit.userCreated': 'Пользователь создан',
    'audit.userUpdated': 'Пользователь изменён',
    'audit.userDeleted': 'Пользователь удалён',
    'audit.objectCreated': 'Объект создан',
    'audit.objectUpdated': 'Объект изменён',
    'audit.objectDeleted': 'Объект удалён',
    'audit.geofenceUpdated': 'Геозона изменена',
    'audit.rulesUpdated': 'Правила изменены',
    'audit.monthClosed': 'Месяц закрыт',
    'audit.monthReopened': 'Месяц открыт',
    'audit.roleChanged': 'Роль изменена',
    'audit.absenceMarked': 'Отсутствие отмечено',
    
    // Live View
    'live.title': 'Мониторинг',
    'live.subtitle': 'Отслеживание статуса сотрудников в реальном времени',
    'live.selectObject': 'Выберите объект',
    'live.refresh': 'Обновить',
    'live.working': 'Работают',
    'live.onPause': 'На паузе',
    'live.atLunch': 'На обеде',
    'live.outside': 'Вне зоны',
    'live.noGps': 'Нет GPS',
    'live.violations': 'Нарушения',
    'live.employeesAt': 'Сотрудники на объекте',
    'live.lastUpdated': 'Последнее обновление',
    'live.liveIndicator': 'Live',
    'live.noEmployees': 'На этом объекте нет назначенных сотрудников',
    
    // Month Closing additional  
    'months.january': 'Январь',
    'months.february': 'Февраль',
    'months.march': 'Март',
    'months.april': 'Апрель',
    'months.may': 'Май',
    'months.june': 'Июнь',
    'months.july': 'Июль',
    'months.august': 'Август',
    'months.september': 'Сентябрь',
    'months.october': 'Октябрь',
    'months.november': 'Ноябрь',
    'months.december': 'Декабрь',
    'months.closedAt': 'Закрыт',
    'months.aboutTitle': 'О закрытии месяца',
    'months.aboutItem1': 'Закрытие месяца делает все записи о рабочем времени за этот месяц недоступными для редактирования',
    'months.aboutItem2': 'Сотрудники не могут обновлять свой статус за даты закрытого месяца',
    'months.aboutItem3': 'Только администраторы могут открыть закрытый месяц',
    'months.aboutItem4': 'Все действия по закрытию/открытию месяца записываются в журнал аудита',
    'months.confirmReopen': 'Вы уверены, что хотите открыть {month} {year}? Это действие будет записано в журнал.',
    'months.closeSuccess': '{month} {year} успешно закрыт',
    'months.reopenSuccess': '{month} {year} успешно открыт',
    'months.closeError': 'Не удалось закрыть месяц',
    'months.reopenError': 'Не удалось открыть месяц',
    'months.loadError': 'Не удалось загрузить статус месяцев',
    
    // Login page
    'login.presenceBased': 'Учёт присутствия',
    'login.timeTracking': 'на объектах',
    'login.heroDescription': 'Отслеживайте присутствие сотрудников на рабочих объектах. Без маршрутов, без слежки — только факты.',
    'login.accuracy': 'Точность',
    'login.monitoring': 'Мониторинг',
    'login.setup': 'Настройка',
    'login.welcomeBack': 'С возвращением',
    'login.enterCredentials': 'Введите данные для входа',
    'login.email': 'Email',
    'login.password': 'Пароль',
    'login.signIn': 'Войти',
    'login.noAccount': 'Нет аккаунта?',
    'login.registerCompany': 'Зарегистрировать компанию',
    'login.loginFailed': 'Ошибка входа. Попробуйте ещё раз.',
    'login.demoHint': 'Демо',
    'login.forgotPassword': 'Забыли пароль?',
    'acceptInvite.title': 'Установите пароль',
    'acceptInvite.subtitle': 'Создайте пароль для активации аккаунта Work+',
    'acceptInvite.submit': 'Активировать аккаунт',
    'acceptInvite.invalidTitle': 'Ссылка недействительна или устарела',
    'acceptInvite.invalidBody': 'Обратитесь к администратору для повторной отправки приглашения.',
    'acceptInvite.doneTitle': 'Аккаунт активирован!',
    'acceptInvite.doneBody': 'Перенаправление на страницу входа...',
    'acceptInvite.error': 'Что-то пошло не так. Попробуйте снова.',
    'employees.inviteSent': 'Приглашение отправлено на email сотрудника',
    'forgotPassword.title': 'Восстановление пароля',
    'forgotPassword.subtitle': 'Введите ваш email и мы отправим ссылку для сброса',
    'forgotPassword.send': 'Отправить ссылку',
    'forgotPassword.sentTitle': 'Проверьте почту',
    'forgotPassword.sentBody': 'Если этот email зарегистрирован, вы получите письмо со ссылкой для сброса пароля.',
    'forgotPassword.backToLogin': 'Назад к входу',
    'forgotPassword.error': 'Что-то пошло не так. Попробуйте снова.',
    'resetPassword.title': 'Новый пароль',
    'resetPassword.submit': 'Установить пароль',
    'resetPassword.invalidTitle': 'Ссылка недействительна или устарела',
    'resetPassword.invalidBody': 'Запросите новую ссылку для сброса пароля.',
    'resetPassword.doneTitle': 'Пароль изменён!',
    'resetPassword.doneBody': 'Перенаправление на страницу входа...',
    'resetPassword.error': 'Что-то пошло не так. Попробуйте снова.',
    
    // Register page
    'register.joinToday': 'Присоединяйтесь к {appName}',
    'register.heroDescription': 'Начните отслеживать присутствие на ваших объектах. Просто, прозрачно и эффективно.',
    'register.createAccount': 'Создание аккаунта',
    'register.enterDetails': 'Заполните данные для начала работы',
    'register.fullName': 'Полное имя',
    'register.email': 'Email',
    'register.password': 'Пароль',
    'register.confirmPassword': 'Подтвердите пароль',
    'register.createAccountBtn': 'Создать аккаунт',
    'register.haveAccount': 'Уже есть аккаунт?',
    'register.signIn': 'Войти',
    'register.passwordsNoMatch': 'Пароли не совпадают',
    'register.passwordTooShort': 'Пароль должен содержать минимум 6 символов',
    'register.registerFailed': 'Ошибка регистрации. Попробуйте ещё раз.',
    
    // Register Company page
    'registerCompany.title': 'Зарегистрируйте вашу компанию',
    'registerCompany.freeTrial': '30 дней бесплатно',
    'registerCompany.companyData': 'Данные компании',
    'registerCompany.companyName': 'Название компании',
    'registerCompany.companyNamePlaceholder': 'Название компании',
    'registerCompany.companyEmail': 'Email компании',
    'registerCompany.phone': 'Телефон',
    'registerCompany.phonePlaceholder': '+372 ...',
    'registerCompany.address': 'Адрес',
    'registerCompany.addressPlaceholder': 'Таллинн',
    'registerCompany.adminData': 'Данные администратора',
    'registerCompany.adminName': 'Ваше имя',
    'registerCompany.adminNamePlaceholder': 'Иван Иванов',
    'registerCompany.adminEmail': 'Email для входа администратора',
    'registerCompany.sameAsCompany': 'Тот же что email компании',
    'registerCompany.password': 'Пароль',
    'registerCompany.createAccount': 'Создать аккаунт компании',
    'registerCompany.haveAccount': 'Уже есть аккаунт?',
    'registerCompany.signIn': 'Войти',
    'registerCompany.trialInfo': '30 дней бесплатно • до 10 сотрудников • все функции',
    'registerCompany.registrationFailed': 'Ошибка регистрации',
    'registerCompany.pwMin8': 'Минимум 8 символов',
    'registerCompany.pwLetter': 'Минимум одна буква',
    'registerCompany.pwDigit': 'Минимум одна цифра',
    'registerCompany.pwInvalid': 'Пароль должен содержать минимум 8 символов, букву и цифру',
    'registerCompany.agreeTerms': 'Я прочитал(а) и соглашаюсь с',
    'registerCompany.termsLink': 'Условиями использования',
    'registerCompany.agreePrivacy': 'Я прочитал(а) и соглашаюсь с',
    'registerCompany.privacyLink': 'Политикой конфиденциальности',
    'registerCompany.consentRequired': 'Необходимо принять условия использования и политику конфиденциальности',
  },
  
  et: {
    // Common
    'app.name': 'Work+',
    'app.tagline': 'Kohaloleku jälgimine',
    'common.loading': 'Laadimine...',
    'common.save': 'Salvesta',
    'common.cancel': 'Tühista',
    'common.filters': 'Filtrid',
    'common.from': 'Alates',
    'common.to': 'Kuni',
    'common.delete': 'Kustuta',
    'common.edit': 'Muuda',
    'common.create': 'Loo',
    'common.search': 'Otsi',
    'common.filter': 'Filter',
    'common.export': 'Eksport',
    'common.refresh': 'Värskenda',
    'common.close': 'Sulge',
    'common.open': 'Ava',
    'common.yes': 'Jah',
    'common.no': 'Ei',
    'common.all': 'Kõik',
    'common.none': 'Puudub',
    'common.active': 'Aktiivne',
    'common.inactive': 'Mitteaktiivne',
    'common.add': 'Lisa',
    'common.name': 'Nimi',
    'common.email': 'E-post',
    'common.password': 'Parool',
    'common.role': 'Roll',
    'common.status': 'Staatus',
    'common.actions': 'Tegevused',
    'common.date': 'Kuupäev',
    'common.created': 'Loodud',
    'common.allRoles': 'Kõik rollid',
    'common.employee': 'Töötaja',
    'common.object': 'Objekt',
    'common.allEmployees': 'Kõik töötajad',
    'common.allObjects': 'Kõik objektid',
    'common.assigned': 'määratud',
    'common.work': 'Töö',
    'common.out': 'Väljas',
    'common.import': 'Import',
    'common.template': 'Mall',
    'common.download': 'Laadi alla',
    'common.upload': 'Laadi üles',
    'common.saveChanges': 'Salvesta',
    'common.update': 'Uuenda',
    'common.type': 'Tüüp',
    'common.configured': 'Seadistatud',
    'common.description': 'Kirjeldus',
    'common.time': 'Aeg',
    'common.address': 'Aadress',
    'common.timezone': 'Ajavöönd',
    'common.noData': 'Andmed puuduvad',
    'common.confirmDelete': 'Kas olete kindel, et soovite kustutada?',
    'common.rules': 'Reeglid',
    
    // Dialogs
    'dialog.editEmployee': 'Muuda töötajat',
    'dialog.bulkImport': 'Hulgiimport töötajad',
    'dialog.bulkImportDesc': 'Impordi mitu töötajat CSV failist',
    'dialog.downloadTemplate': 'Laadi alla CSV mall',
    'dialog.getFormat': 'Õige vormingu saamiseks',
    'dialog.uploadFile': 'Laadi üles CSV fail',
    'dialog.pasteCSV': 'Või kleepige CSV sisu',
    'dialog.csvFormat': 'CSV vorming:',
    'dialog.nameRequired': 'name (nõutav): Töötaja täisnimi',
    'dialog.emailRequired': 'email (nõutav): Unikaalne e-posti aadress',
    'dialog.passwordOptional': 'password (valikuline): Vaikimisi "changeme123"',
    'dialog.roleOptional': 'role (valikuline): admin, hr, controller või employee',
    'dialog.objectsOptional': 'assigned_objects (valikuline): Objekti ID-d semikooloniga eraldatud',
    'dialog.noObjectsAvailable': 'Objekte pole saadaval',
    'dialog.accountActive': 'Konto aktiivne',
    'dialog.notesAbout': 'Märkmed töötaja kohta',
    
    // Objects form
    'objects.bufferZone': 'Puhvertsoon (m)',
    'objects.gracePeriod': 'Ooteperiood (min)',
    'objects.pauseAllowed': 'Paus lubatud',
    'objects.maxTimesHour': 'Max korda/tund',
    'objects.maxMinutesShift': 'Max minutid/vahetus',
    'objects.lunchAllowed': 'Lõuna lubatud',
    'objects.lunchMandatory': 'Lõuna kohustuslik',
    'objects.minDuration': 'Min kestus (min)',
    'objects.maxDuration': 'Max kestus (min)',
    'objects.shiftSettings': 'Vahetuse seaded',
    'objects.shiftStart': 'Vahetuse algus',
    'objects.shiftEnd': 'Vahetuse lõpp',
    'objects.countEarlyArrival': 'Arvesta varajast saabumist',
    'objects.countOvertime': 'Arvesta ületunde',
    'objects.maxOvertime': 'Max ületunnid (min)',
    'objects.geofenceRadius': 'Geopiiri raadius',
    'objects.noObjectsYet': 'Objekte veel pole',
    'objects.createFirst': 'Loo oma esimene töökoht kohaloleku jälgimiseks',
    
    // Map
    'map.enterAddress': 'Sisesta aadress...',
    'map.search': 'Otsi',
    'map.searching': 'Otsin...',
    'map.myLocation': 'Minu asukoht',
    'map.latitude': 'Laiuskraad',
    'map.longitude': 'Pikkuskraad',
    'map.radius': 'Raadius (m)',
    'map.clickToSelect': 'Klõpsa kaardil punkti valimiseks',
    'map.addressNotFound': 'Aadressi ei leitud',
    'map.geolocationError': 'Asukoha tuvastamine ebaõnnestus',
    'map.selectBuilding': 'Vali hoone',
    'map.currentLocation': 'Praegune asukoht',
    'map.buildingAvailable': 'Hoone kontuur',
    'map.useBuildingOutline': 'Kasuta hoone kontuuri geopiirana',
    'map.buildingModeHint': 'Hoone kontuur on kasutusel geopiirana',
    'map.geofenceMode': 'Geopiiri tüüp',
    'map.circleRadius': 'Ring (raadius)',
    'map.buildingOutline': 'Hoone kontuur',
    'map.building': 'Hoone',
    'map.nextBuilding': 'Järgmine hoone',
    'map.clickBuildingHint': 'Klõpsa soovitud hoonel kaardil selle valimiseks',
    'map.noBuildingOutline': 'Hoone kontuur pole selle aadressi jaoks saadaval',
    'map.detectBuilding': 'Tuvasta hoone',
    'map.noBuildingFound': 'Selles asukohas hoonet ei leitud',
    'map.modeCircle': 'Ring',
    'map.modeBuilding': 'Hoone',
    'map.modeDraw': 'Joonista',
    'map.buildingHint': 'Vali kaardil asukoht, seejärel tuvasta hoone kontuur OpenStreetMapist',
    'map.drawHint': 'Klõpsa "Alusta joonistamist", seejärel klõpsa kaardil punktide lisamiseks. Minimaalselt 3 punkti.',
    'map.startDraw': 'Alusta joonistamist',
    'map.drawingActive': 'Joonistamisrežiim',
    'map.points': 'p.',
    'map.finishDraw': 'Lõpeta tsoon',
    'map.zoneDrawn': 'Tsoon valmis',
    'map.editPoints': 'Muuda punkte',
    'map.redraw': 'Joonista uuesti',
    'map.enterAddress': 'Sisesta aadress...',
    'map.searching': 'Otsimine...',
    'map.myLocation': 'Minu asukoht',
    'map.radius': 'Raadius',

    // Violations
    'violations.totalInPeriod': 'Rikkumisi valitud perioodil kokku',
    'violations.noViolations': 'Rikkumisi ei leitud',
    'violations.pauseLimitExceeded': 'Pauside limiit ületatud',
    'violations.lunchDurationExceeded': 'Lõuna kestus ületatud',
    'violations.frequentOutside': 'Sage väljas viibimine',
    'violations.frequentNoGps': 'Sage GPS puudumine',
    
    // Messages
    'msg.employeeUpdated': 'Töötaja uuendatud',
    'msg.employeeDeleted': 'Töötaja kustutatud',
    'msg.failedUpdate': 'Uuendamine ebaõnnestus',
    'msg.failedDelete': 'Kustutamine ebaõnnestus',
    'msg.failedLoad': 'Andmete laadimine ebaõnnestus',
    'msg.exportSuccess': 'Eksport õnnestus',
    'msg.exportError': 'Ekspordi viga',
    'msg.importComplete': 'Import lõpetatud',
    'msg.importFailed': 'Import ebaõnnestus',
    'msg.noValidData': 'Kehtivaid andmeid ei leitud',
    'msg.objectCreated': 'Objekt loodud',
    'msg.objectUpdated': 'Objekt uuendatud',
    'msg.objectDeleted': 'Objekt kustutatud',
    'msg.error': 'Tekkis viga',

    // API error translations (backend messages)
    'error.invalidCredentials': 'Vale e-post või parool',

    // Password strength
    'password.weak': 'Nõrk parool',
    'password.medium': 'Rahuldav',
    'password.good': 'Hea parool',
    'password.strong': 'Tugev parool',
    'password.hint': 'vähemalt 8 tähemärki, tähed ja numbrid',
    'error.tooManyAttempts': 'Liiga palju sisselogimiskatseid. Proovige 10 minuti pärast uuesti.',
    'error.accountDisabled': 'Teie konto on keelatud. Võtke ühendust toega.',
    'error.companyDisabled': 'Ettevõtte konto on keelatud. Võtke ühendust toega.',
    'error.trialExpired': 'Prooviperiood on lõppenud. Võtke ühendust toega.',
    'error.tokenExpired': 'Seanss on aegunud. Palun logige uuesti sisse.',
    'error.invalidToken': 'Link on kehtetu või aegunud.',
    'error.userNotFound': 'Kasutajat ei leitud.',
    'error.emailInUse': 'See e-posti aadress on juba kasutusel.',
    'error.wrongPassword': 'Praegune parool on vale.',
    'error.passwordTooShort': 'Parool peab olema vähemalt 8 tähemärki pikk.',
    'error.invalidInvite': 'Kutselink on kehtetu või aegunud.',
    'error.inviteExpired': 'Kutse on aegunud.',
    'error.emailAlreadyRegistered': 'See e-post on juba registreeritud. Palun logige sisse.',
    'error.companyEmailTaken': 'Selle e-postiga ettevõte on juba olemas.',
    'error.adminNameRequired': 'Administraatori nimi on kohustuslik.',
    'error.companyNameRequired': 'Ettevõtte nimi on kohustuslik.',
    'error.invalidEmail': 'E-posti aadress on vigane.',
    'error.maxEmployeesReached': 'Ettevõte on saavutanud töötajate maksimumarvu.',
    'error.userEmailExists': 'Selle e-postiga kasutaja on juba olemas.',
    'error.selfRegNotAvailable': 'Iseseisvregistreerimine pole saadaval. Pöörduge administraatori poole.',
    'error.nothingToUpdate': 'Muudatusi pole.',
    'error.cannotDeleteSelf': 'Oma kontot ei saa kustutada.',
    'error.cannotRemoveLastAdmin': 'Ettevõtte viimast administraatorit ei saa eemaldada.',
    'error.noCompany': 'Selle kontoga pole ettevõtet seotud.',
    'error.companyNotFound': 'Ettevõtet ei leitud.',
    'msg.failedLoad': 'Andmete laadimine ebaõnnestus',
    
    // Rikkumiste tüübid
    'violations.type.pause_limit_exceeded': 'Pausilimiit ületatud',
    'violations.type.lunch_duration_exceeded': 'Lõunapaus ületatud',
    'violations.type.frequent_outside': 'Sagedased väljumised',
    'violations.type.frequent_no_gps': 'Sagedane GPS puudumine',
    'violations.type.no_show': 'Puudumine',
    'violations.type.late_arrival': 'Hilinemine',
    'violations.type.pause_exceeded': 'Paus ületatud',
    'violations.type.lunch_exceeded': 'Lõuna ületatud',
    
    // Live vaade
    'live.dataStale': 'Andmed võivad olla aegunud',
    'live.live': 'Otse-eetris',
    'live.noSignal': 'Signaal puudub',
    'live.lastSeen': 'Viimati nähtud',
    'live.minsAgo': ' min tagasi',
    'live.hoursAgo': 'h tagasi',
    
    // Aruanded
    'reports.noDataToExport': 'Ekspordiks andmed puuduvad',
    
    // Töötaja
    'employee.notificationsEnabled': 'Teavitused lubatud',
    'employee.notificationsFailed': 'Teavituste lubamine ebaõnnestus',
    'employee.locationUpdated': 'Asukoht uuendatud',
    
    // Employees
    'employees.addEmployee': 'Lisa töötaja',
    'employees.namePlaceholder': 'Täisnimi',
    'employees.newPassword': 'Uus parool',
    'employees.leaveEmptyPassword': 'Jäta tühjaks praeguse säilitamiseks',
    'employees.enterPassword': 'Sisesta parool',
    'employees.defaultPasswordHint': 'Vaikimisi: changeme123',
    'employees.confirmDelete': 'Kustuta see töötaja?',
    'employees.msg.updated': 'Töötaja uuendatud',
    'employees.msg.created': 'Töötaja loodud',
    'employees.msg.deleted': 'Töötaja kustutatud',
    'employees.msg.emailRequired': 'E-post on kohustuslik',
    'employees.msg.nameRequired': 'Nimi on kohustuslik',
    'employees.msg.passwordTooShort': 'Parool peab olema vähemalt 6 tähemärki',
    'employees.msg.passwordWeak': 'Parool peab olema vähemalt 8 tähemärki ning sisaldama tähte ja numbrit',
    'employees.msg.passwordOk': 'Parool vastab nõuetele',
    'employees.import.noCsvData': 'Sisesta või laadi üles CSV andmed',
    'employees.import.missingHeaders': 'CSV peab sisaldama veerge "name" ja "email"',
    'employees.import.lineError': 'Rida {line}: puudub nimi või e-post',
    'employees.import.formatHint': 'CSV formaat: name,email,password,role,objects',
    
    // Trial & session (ET)
    'login.sessionExpired': 'Teie seanss on aegunud. Palun logige uuesti sisse.',
    'trial.daysLeft': 'Proovperiood lõpeb {n} päeva pärast. ',
    'trial.expired': 'Teie proovperiood on lõppenud. ',
    'trial.contactSupport': 'Aktiveerimiseks võtke ühendust toega.',
    
    // Employee objects warning (ET)
    'employee.noObjectsAssigned': 'Ühtegi töökohta pole määratud',
    'employee.noObjectsHint': 'Pöörduge administraatori poole töökoha määramiseks. GPS jälgimine ei tööta kuni teile pole töökohta määratud.',
    'employee.gpsBackgroundTip': 'Hoidke leht avatud täpse GPS jälgimise jaoks',
    'employee.gpsBackgroundHint': 'Teie brauser ei toeta GPS-i taustal. Asukoha jälgimiseks lukustatud ekraaniga: installige rakendus (Lisa avakuvale) ja hoidke ekraan tööl olles sisse lülitatuna.',
    'employee.myObjects': 'Minu töökohad',
    'employee.here': 'Aktiivne',
    'employee.todayWork': 'Töö täna',
    'employee.todayPause': 'Pausid',
    'employee.todayLunch': 'Lõuna',
    'employee.todayHistory': 'Tänane kokkuvõte',
    'employee.pastDays': 'Varasemad päevad',
    'employee.myHistory': 'Minu ajalugu',
    'employee.workingAt': 'Töötad praegu objektil',
    'employee.currentObject': 'Objekt',
    'employee.myHistoryTitle': 'Minu ajalugu',
    'employee.selectMonth': 'Vali kuu',
    'employee.noDataForPeriod': 'Andmed puuduvad',
    'employee.dayDetail': 'Päeva detailid',
    'employee.violations': 'Rikkumised',
    'employee.noViolations': 'Rikkumisi pole',
    'notes.showMore': 'Kuva rohkem',
    'notes.roleEmployee': 'Töötaja',
    'notes.roleManager': 'Juht',
    'notes.clearAll': 'Tühjenda kõik',
    'notes.clearAllConfirm': 'Kustutada kõik märkmed? Seda ei saa tagasi võtta.',
    'notes.aboutEmployee': 'Märkmed töötaja kohta',
    'notes.add': 'Lisa',
    'notes.save': 'Salvesta',
    'notes.cancel': 'Tühista',
    'notes.placeholder': 'Märkme tekst...',
    'notes.visibleToEmployee': 'Nähtav töötajale (ilmub tema päevikusse)',
    'notes.hiddenForManagement': 'Peidetud — ainult juhtkonnale',
    'notes.journalLabel': 'Päevik (nähtav töötajale)',
    'notes.hiddenNotes': 'Peidetud märkmed',
    'notes.noEntries': 'Kandeid pole veel',
    'notes.imagePreview': 'Pildi eelvaade',
    'employee.historyEmpty': 'Kandeid pole',
    'employee.showHistory': 'Näita ajalugu',
    'employee.hideHistory': 'Peida ajalugu',
    'employee.active': 'Aktiivne',

    // Auth
    'auth.login': 'Logi sisse',
    'auth.logout': 'Logi välja',
    'auth.register': 'Registreeri',
    'auth.email': 'E-post',
    'auth.password': 'Parool',
    'auth.confirmPassword': 'Kinnita parool',
    'auth.name': 'Täisnimi',
    'auth.welcomeBack': 'Tere tulemast tagasi',
    'auth.createAccount': 'Loo konto',
    'auth.enterCredentials': 'Sisesta oma andmed sisselogimiseks',
    'auth.noAccount': 'Pole kontot?',
    'auth.haveAccount': 'On juba konto?',
    
    // Absences
    'absences.title': 'Puudumised',
    'absences.subtitle': 'Töötajate puudumiste arvestus',
    'absences.addAbsence': 'Lisa puudumine',
    'absences.editRecord': 'Muuda kirjet',
    'absences.employee': 'Töötaja',
    'absences.type': 'Tüüp',
    'absences.absenceType': 'Puudumise tüüp',
    'absences.reason': 'Põhjus',
    'absences.reasonPlaceholder': 'Kirjelda puudumise põhjust...',
    'absences.modifiedBy': 'Muudetud',
    'absences.allEmployees': 'Kõik töötajad',
    'absences.selectEmployee': 'Vali töötaja',
    'absences.noRecords': 'Puudumiste kirjeid pole',
    'absences.excused': 'Põhjusega',
    'absences.unexcused': 'Põhjuseta',
    'absences.excusedReason': 'Põhjusega puudumine',
    'absences.confirmDelete': 'Kustuta see kirje?',
    'absences.msg.added': 'Puudumine lisatud',
    'absences.msg.updated': 'Kirje uuendatud',
    'absences.msg.deleted': 'Kirje kustutatud',
    'absences.type.noShow': 'Ei ilmunud',
    'absences.type.sick': 'Haigus',
    'absences.type.vacation': 'Puhkus',
    'absences.type.personal': 'Isiklikud põhjused',
    'absences.type.other': 'Muu',
    
    // Super Admin
    'superAdmin.title': 'Super Admin',
    'superAdmin.subtitle': 'Platvormi ettevõtete haldus',
    'superAdmin.tabDashboard': 'Ülevaade',
    'superAdmin.tabCompanies': 'Ettevõtted',
    'superAdmin.tabEmployees': 'Töötajad',
    'superAdmin.tabAudit': 'Audit',
    'superAdmin.allCompanies': 'Kõik ettevõtted',
    'superAdmin.auditWho': 'Kes',
    'superAdmin.auditAction': 'Tegevus',
    'superAdmin.auditDetails': 'Üksikasjad',
    'superAdmin.auditWhen': 'Millal',
    'superAdmin.noAudit': 'Auditiridu pole',
    'superAdmin.records': 'kirjet',
    'superAdmin.confirmRemoveUser': 'Seda toimingut ei saa tagasi võtta.',
    'superAdmin.totalCompanies': 'Ettevõtteid kokku',
    'superAdmin.activeCompanies': 'Aktiivsed',
    'superAdmin.trialCompanies': 'Prooviperioodil',
    'superAdmin.totalEmployees': 'Töötajaid kokku',
    'superAdmin.searchPlaceholder': 'Otsi ettevõtet...',
    'superAdmin.noCompanies': 'Ettevõtteid pole',
    'superAdmin.companiesWillAppear': 'Ettevõtted ilmuvad pärast registreerimist',
    'superAdmin.company': 'Ettevõte',
    'superAdmin.subscription': 'Tellimus',
    'superAdmin.status': 'Staatus',
    'superAdmin.employees': 'Töötajad',
    'superAdmin.created': 'Loodud',
    'superAdmin.actions': 'Tegevused',
    'superAdmin.subscriptionActive': 'Aktiivne',
    'superAdmin.subscriptionTrial': 'Prooviperiood',
    'superAdmin.subscriptionPastDue': 'Tähtaja ületanud',
    'superAdmin.subscriptionCanceled': 'Tühistatud',
    'superAdmin.subscriptionExpired': 'Aegunud',
    'superAdmin.planTrial': 'Proov',
    'superAdmin.planStarter': 'Starter',
    'superAdmin.planBusiness': 'Business',
    'superAdmin.planEnterprise': 'Enterprise',
    'superAdmin.companyUsers': 'Ettevõtte kasutajad',
    'superAdmin.employeeLimit': 'Töötajate limiit',
    'superAdmin.trialEnds': 'Proov lõppeb',
    'superAdmin.noUsers': 'Kasutajaid pole',
    'superAdmin.objects': 'Objektid',
    'superAdmin.workHoursThisMonth': 'Töötunnid (see kuu)',
    'superAdmin.violationsThisMonth': 'Rikkumised (see kuu)',
    'superAdmin.viewDetails': 'Vaata üksikasju',
    'superAdmin.activate': 'Aktiveeri',
    'superAdmin.deactivate': 'Deaktiveeri',
    'superAdmin.companyActivated': 'Ettevõte aktiveeritud',
    'superAdmin.companyDeactivated': 'Ettevõte deaktiveeritud',
    'superAdmin.loadError': 'Ettevõtete laadimine ebaõnnestus',
    'superAdmin.accessDenied': 'Juurdepääs keelatud. Vajalik Super Admin roll',
    
    // Super Admin - Extended
    'superAdmin.createCompany': 'Loo ettevõte',
    'superAdmin.editCompany': 'Muuda ettevõtet',
    'superAdmin.deleteCompany': 'Kustuta ettevõte',
    'superAdmin.confirmDelete': 'Kas olete kindel, et soovite selle ettevõtte kustutada? Kõik andmed kustutatakse jäädavalt.',
    'superAdmin.companyCreated': 'Ettevõte edukalt loodud',
    'superAdmin.companyUpdated': 'Ettevõte edukalt uuendatud',
    'superAdmin.companyDeleted': 'Ettevõte edukalt kustutatud',
    'superAdmin.editSubscription': 'Muuda tellimust',
    'superAdmin.subscriptionUpdated': 'Tellimus edukalt uuendatud',
    'superAdmin.plan': 'Plaan',
    'superAdmin.maxEmployees': 'Max töötajaid',
    'superAdmin.extendTrial': 'Pikenda prooviperioodi',
    'superAdmin.trialDays': 'Prooviperioodi päevad',
    'superAdmin.addUser': 'Lisa kasutaja',
    'superAdmin.removeUser': 'Eemalda kasutaja',
    'superAdmin.resetPassword': 'Lähtesta parool',
    'superAdmin.newPassword': 'Uus parool',
    'superAdmin.userAdded': 'Kasutaja edukalt lisatud',
    'superAdmin.userRemoved': 'Kasutaja edukalt eemaldatud',
    'superAdmin.passwordReset': 'Parool edukalt lähtestatud',
    'superAdmin.confirmRemoveUser': 'Kas olete kindel, et soovite selle kasutaja eemaldada?',
    'superAdmin.cannotRemoveLastAdmin': 'Viimast administraatorit ei saa eemaldada',
    'superAdmin.adminName': 'Administraatori nimi',
    'superAdmin.adminEmail': 'Administraatori e-post',
    'superAdmin.adminPassword': 'Administraatori parool',
    'superAdmin.selectRole': 'Vali roll',
    'superAdmin.userEmail': 'Kasutaja e-post',
    'superAdmin.userName': 'Kasutaja nimi',
    'superAdmin.companyName': 'Ettevõtte nimi',
    'superAdmin.companyEmail': 'Ettevõtte e-post',
    'superAdmin.phone': 'Telefon',
    'superAdmin.address': 'Aadress',
    'superAdmin.adminData': 'Administraatori andmed',
    
    // Billing page
    'billing.title': 'Tellimus',
    'billing.subtitle': 'Halda oma ettevõtte tellimusplaani',
    'billing.currentPlan': 'Praegune plaan',
    'billing.trialPeriod': 'Prooviperiood',
    'billing.expires': 'Aegub',
    'billing.active': 'Aktiivne',
    'billing.employeeLimit': 'Töötajate limiit',
    'billing.trialWarning': 'Teie prooviperiood lõppeb peagi. Valige plaan töö jätkamiseks.',
    'billing.checkingPayment': 'Kontrollime makse staatust...',
    'billing.paymentSuccess': 'Makse õnnestus! Tellimus aktiveeritud.',
    'billing.sessionExpired': 'Makse seanss aegus. Proovige uuesti.',
    'billing.checkEmail': 'Kontrollige e-posti makse kinnituse saamiseks.',
    'billing.checkoutError': 'Makse seansi loomine ebaõnnestus',
    'billing.perMonth': '/kuu',
    'billing.upToEmployees': 'Kuni {count} töötajat',
    'billing.allFeatures': 'Kõik funktsioonid',
    'billing.emailSupport': 'E-posti tugi',
    'billing.prioritySupport': 'Prioriteetne tugi',
    'billing.select': 'Vali',
    'billing.currentPlanBadge': 'Praegune',
    'billing.currentPlanBtn': 'Praegune plaan',
    'billing.securePayment': 'Turvaline makse Stripe kaudu. Tühista igal ajal.',
    
    // Salaries page
    'salaries.title': 'Palgad',
    'salaries.subtitle': 'Töötajate palkade haldamine ja arvutamine',
    'salaries.calculate': 'Arvuta',
    'salaries.selectEmployee': 'Vali töötaja',
    'salaries.selectPeriod': 'Vali periood',
    'salaries.noConfig': 'Sellel töötajal puudub palgakonfiguratsioon',
    'salaries.notConfigured': 'Seadistamata',
    'salaries.setupSalary': 'Seadista palk',
    'salaries.salaryType': 'Palga tüüp',
    'salaries.hourly': 'Tunnitasu',
    'salaries.daily': 'Päevatasu',
    'salaries.monthly': 'Kuupalk',
    'salaries.baseAmount': 'Baassumma',
    'salaries.currency': 'Valuuta',
    'salaries.overtimeMultiplier': 'Ületunnitöö kordaja',
    'salaries.nightBonus': 'Öötöö boonus',
    'salaries.weekendBonus': 'Nädalavahetuse boonus',
    'salaries.regularHours': 'Tavalised tunnid',
    'salaries.overtimeHours': 'Ületunnid',
    'salaries.nightHours': 'Öötunnid',
    'salaries.weekendHours': 'Nädalavahetuse tunnid',
    'salaries.basePay': 'Baaspalk',
    'salaries.overtimePay': 'Ületunnitasu',
    'salaries.nightBonusPay': 'Öötöö boonus',
    'salaries.weekendBonusPay': 'Nädalavahetuse boonus',
    'salaries.totalGross': 'Kokku (bruto)',
    'salaries.period': 'Periood',
    'salaries.configSaved': 'Palgakonfiguratsioon salvestatud',
    'salaries.configError': 'Palgakonfiguratsiooni salvestamine ebaõnnestus',
    'salaries.calcError': 'Palga arvutamine ebaõnnestus',
    
    // Settings page
    'settings.title': 'Seaded',
    'settings.subtitle': 'Ettevõtte seaded ja konfiguratsioon',
    'settings.companyInfo': 'Ettevõtte info',
    'settings.companyName': 'Ettevõtte nimi',
    'settings.companyEmail': 'Ettevõtte e-post',
    'settings.phone': 'Telefon',
    'settings.address': 'Aadress',
    'settings.subscriptionInfo': 'Tellimuse info',
    'settings.plan': 'Plaan',
    'settings.status': 'Staatus',
    'settings.employees': 'Töötajad',
    'settings.trialEnds': 'Proov lõppeb',
    'settings.notifications': 'Teavitused',
    'settings.notificationsDesc': 'Seadistage kuidas teavitusi saate',
    'settings.emailNotifications': 'E-posti teavitused',
    'settings.pushNotifications': 'Push teavitused',
    'settings.violationAlerts': 'Rikkumiste hoiatused',
    'settings.saveSuccess': 'Seaded salvestatud',
    'settings.saveError': 'Seadete salvestamine ebaõnnestus',
    
    // Navigation
    'nav.dashboard': 'Töölaud',
    'nav.liveView': 'Reaalajas',
    'nav.objects': 'Objektid',
    'nav.employees': 'Töötajad',
    'nav.reports': 'Aruanded',
    'nav.violations': 'Rikkumised',
    'nav.absences': 'Puudumised',
    'nav.monthClosing': 'Kuu sulgemine',
    'nav.schedule': 'Graafik',
    'schedule.allObjects': 'Kõik objektid',
    'schedule.templates': 'Mallid',
    'schedule.template': 'Mall',
    'schedule.selectTemplate': 'Vali mall…',
    'schedule.startTime': 'Algus',
    'schedule.endTime': 'Lõpp',
    'schedule.saved': 'Salvestatud',
    'schedule.deleted': 'Kustutatud',
    'schedule.cleared': 'Tühjendatud',
    'schedule.noShiftsThisWeek': 'Sel nädalal pole vahetusi',
    'schedule.copiedShifts': 'vahetust kopeeritud',
    'schedule.created': 'vahetust loodud',
    'schedule.allFilled': 'Kõik tööpäevad on juba täidetud',
    'schedule.confirmClear': 'Kustuta kõik selle töötaja vahetused sel kuul?',
    'schedule.copyWeek': 'Kopeeri nädal',
    'schedule.clearMonth': 'Tühjenda kuu',
    'schedule.fillWeekdays': 'Täida E–R',
    'schedule.noEmployees': 'Töötajaid ei leitud',
    'schedule.manageTemplates': 'Vahetuse mallid',
    'schedule.newTemplate': 'Uus mall',
    'schedule.templateName': 'Nimi',
    'schedule.addTemplate': 'Lisa mall',
    'schedule.color': 'Värv',
    'schedule.templateSaved': 'Mall salvestatud',
    'schedule.templateNameRequired': 'Sisesta malli nimi',
    'schedule.myShiftToday': 'Minu vahetus täna',
    'schedule.noShiftToday': 'Vahetust pole määratud',
    'schedule.thisWeek': 'See nädal',
    'nav.mySchedule': 'Minu graafik',
    'nav.myObjects': 'Minu objektid',
    'nav.myHistory': 'Minu ajalugu',
    'nav.myNotes': 'Märkmed',
    
    // My Objects
    'myObjects.title': 'Minu tööobjektid',
    'myObjects.subtitle': 'Sinu määratud tööobjektid',
    'myObjects.noObjects': 'Sa ei ole ühelegi objektile määratud',
    'myObjects.radius': 'Raadius',
    'myObjects.drawnZone': 'Joonistatud tsoon',
    'myObjects.building': 'Hoone',
    'myObjects.pauseAllowed': 'Paus lubatud',
    'myObjects.pauseNotAllowed': 'Paus keelatud',
    'myObjects.lunchAllowed': 'Lõuna lubatud',
    'myObjects.lunchNotAllowed': 'Lõuna keelatud',
    'myObjects.gracePeriod': 'Hilinemise lubavus',
    'myObjects.nextShift': 'Järgmine vahetus',
    'myObjects.openMap': 'Ava kaardil',
    'myObjects.min': 'min',
    
    'schedule.activeObject': 'Aktiivne objekt',
    'schedule.fromSchedule': 'Graafikust',
    'schedule.switchObject': 'Vaheta objekti',
    'schedule.shiftConflict': 'Vahetused kattuvad',
    'schedule.maxShifts': 'Maksimaalselt 2 vahetust päevas',
    'schedule.dayOff': 'Puhkepäev',
    'schedule.viewFullSchedule': 'Vaata kogu graafikut',
    'audit.from': 'Alates',
    'audit.to': 'Kuni',
    'nav.audit': 'Auditilogi',
    'nav.billing': 'Arveldus',
    'nav.salaries': 'Palgad',
    'nav.superAdmin': 'Super Admin',
    'nav.settings': 'Seaded',
    
    // Statuses
    'status.working': 'Töötab',
    'status.pause': 'Paus',
    'status.lunch': 'Lõuna',
    'status.outside': 'Väljas',
    'status.no_gps': 'GPS puudub',
    'status.onPause': 'Pausil',
    'status.atLunch': 'Lõunal',
    
    // Roles
    'role.admin': 'Administraator',
    'role.hr': 'HR',
    'role.controller': 'Kontroller',
    'role.employee': 'Töötaja',
    'role.custom': 'Muu (sisesta käsitsi)',
    'role.customPlaceholder': 'Sisesta ametikoha nimetus...',
    'dashboard.title': 'Töölaud',
    'dashboard.welcome': 'Tere tulemast',
    'dashboard.gpsTabWarning': 'GPS on aktiivne — hoia see vahekaart avatud täpse jälgimise jaoks',
    'dashboard.presenceOverview': 'Reaalajas kohaloleku ülevaade',
    'dashboard.yourDashboard': 'Teie kohaloleku töölaud',
    'dashboard.currentStatus': 'Praegune staatus',
    'dashboard.thisMonth': 'See kuu',
    'dashboard.totalWorkingTime': 'Kogutööaeg',
    'dashboard.objectsOverview': 'Objektide ülevaade',
    'dashboard.employeesAssigned': 'töötajat määratud',
    'dashboard.liveObjects': 'Aktiivsed objektid',
    'dashboard.objects': 'Objektid',
    'dashboard.violations': 'Rikkumised',
    
    // Employee actions
    'employee.pause': 'Paus',
    'employee.lunch': 'Lõuna',
    'employee.resume': 'Jätka tööd',
    'employee.gpsRequired': 'Asukoha ligipääs vajalik',
    'employee.enableGps': 'Luba tööaja jälgimiseks',
    'employee.enableNotifications': 'Luba teavitused',
    'employee.notificationInfo': 'Saa teavitusi rikkumiste kohta',
    'employee.locationGranted': 'Asukoha ligipääs lubatud',
    'employee.locationDenied': 'Asukoha ligipääs keelatud',
    'employee.notificationsEnabled': 'Teavitused lubatud',
    'employee.notificationsFailed': 'Teavituste lubamine ebaõnnestus',
    'employee.statusUpdated': 'Staatus uuendatud',
    'employee.statusUpdateFailed': 'Staatuse uuendamine ebaõnnestus',
    'employee.myNotes': 'Minu märkmed',
    'employee.noNotes': 'Märkmeid pole',
    'employee.gpsActive': 'GPS Aktiivne',
    'employee.gpsOff': 'GPS Väljas',
    'employee.trackingOn': 'Jälgimine Sees',
    'employee.trackingOff': 'Jälgimine Väljas',
    'employee.notificationsOn': 'Teavitused Sees',
    'employee.enable': 'Luba',
    'employee.notesFromManagement': 'Märkmed juhtkonnalt',
    'employee.from': 'Kellelt',
    'employee.myNotes': 'Minu märkmed',
    'employee.addNote': 'Lisa märge',
    'employee.noteTextPlaceholder': 'Kirjuta märge...',
    'employee.addPhoto': 'Lisa foto',
    'employee.noteSaved': 'Märge salvestatud',
    'employee.noteSaveError': 'Märke salvestamine ebaõnnestus',
    'employee.noteDeleted': 'Märge kustutatud',
    'employee.noteDeleteError': 'Märke kustutamine ebaõnnestus',
    'employee.noNotesYet': 'Märkmeid pole veel. Lisa esimene märge.',
    'employee.activeObjects': 'Aktiivsed objektid',
    'employee.assigned': 'määratud',
    
    // Objects
    'objects.title': 'Objektid',
    'objects.subtitle': 'Halda töökohti ja geopiire',
    'objects.addObject': 'Lisa objekt',
    'objects.createObject': 'Loo objekt',
    'objects.editObject': 'Muuda objekti',
    'objects.basicInfo': 'Põhiinfo',
    'objects.geofence': 'Geopiir',
    'objects.rules': 'Reeglid',
    'objects.assignEmployees': 'Määra töötajad',
    'objects.tab_basic': 'Põhiinfo',
    'objects.tab_geofence': 'Geotsoon',
    'objects.tab_rules': 'Reeglid',
    'objects.tab_employees': 'Töötajad',
    'objects.type': 'Tüüp',
    'objects.type.permanent': 'Alaline',
    'objects.type.temporary': 'Ajutine',
    'objects.permanentType': 'Alaline',
    'objects.temporaryType': 'Ajutine',
    'objects.addressPlaceholder': 'Sisesta aadress',
    'objects.searchAddress': 'Otsi',
    'objects.noObjects': 'Objekte pole. Loo esimene!',
    'objects.noObjectsAdmin': 'Objekte pole. Loo objekte andmete vaatamiseks.',
    'objects.employees': 'töötajat',
    
    // Employees
    'employees.title': 'Töötajad',
    'employees.subtitle': 'Halda töötajate kontosid ja määramisi',
    'employees.bulkImport': 'Hulgiimport',
    'employees.editEmployee': 'Muuda töötajat',
    'employees.assignedObjects': 'Määratud objektid',
    'employees.objectsOnlyForEmployees': 'Objekte saab määrata ainult töötajatele',
    'employees.searchPlaceholder': 'Otsi nime või e-posti järgi...',
    
    // Reports
    'reports.title': 'Aruanded',
    'reports.subtitle': 'Genereeri ja ekspordi kohaloleku aruandeid',
    'reports.generate': 'Genereeri',
    'reports.exportReport': 'Ekspordi aruanne',
    'reports.exportTimesheetCSV': 'Ekspordi tööajatabel CSV',
    'reports.exportTimesheetExcel': 'Ekspordi tööajatabel Excel',
    'reports.documentLanguage': 'Dokumendi keel',
    'reports.startDate': 'Alguskuupäev',
    'reports.endDate': 'Lõppkuupäev',
    'reports.noData': 'Andmed puuduvad. Vali filtrid ja klõpsa Genereeri.',
    'reports.filters': 'Filtrid',
    'reports.working': 'Töö',
    'reports.noGps': 'GPS puudub',
    
    // Violations
    'violations.title': 'Rikkumised',
    'violations.subtitle': 'Jälgi ja vaata üle reeglite rikkumisi',
    'violations.yourHistory': 'Teie rikkumiste ajalugu',
    'violations.totalViolations': 'Rikkumisi valitud perioodil kokku',
    
    // Month Closing
    'months.title': 'Kuu sulgemine',
    'months.subtitle': 'Lukusta kuud, et andmed oleksid kirjutuskaitstud',
    'months.closeMonth': 'Sulge kuu',
    'months.reopen': 'Ava uuesti',
    'months.closed': 'Suletud',
    'months.open': 'Avatud',
    
    // Billing
    'billing.title': 'Arveldus',
    'billing.subtitle': 'Vaata arvelduse üksikasju ja aktiivseid töötajaid',
    'billing.activeEmployees': 'Aktiivsed töötajad',
    'billing.billingTier': 'Hinnapakett',
    'billing.estimatedCost': 'Hinnanguline kulu',
    
    // Settings
    'settings.title': 'Seaded',
    'settings.subtitle': 'Seadista objekti reegleid ja eelistusi',
    'settings.profile': 'Profiil',
    'settings.security': 'Turvalisus',
    'settings.tabProfile': 'Profiil',
    'settings.tabSecurity': 'Turvalisus',
    'settings.tabObjects': 'Objekti reeglid',
    'settings.changePassword': 'Muuda parooli',
    'settings.currentPassword': 'Praegune parool',
    'settings.newPassword': 'Uus parool',
    'settings.confirmPassword': 'Kinnita parool',
    'settings.passwordHint': 'Vähemalt 8 tähemärki, tähed ja numbrid',
    'settings.passwordMismatch': 'Paroolid ei kattu',
    'settings.passwordTooShort': 'Parool peab olema vähemalt 8 tähemärki',
    'settings.passwordWeak': 'Parool peab sisaldama tähti ja numbreid',
    'settings.passwordChanged': 'Parool edukalt muudetud',
    'settings.wrongOldPassword': 'Vale praegune parool',
    'settings.profileSaved': 'Profiil salvestatud',
    'settings.gracePeriod': 'Puhverperiood',
    'settings.pauseRules': 'Pausi reeglid',
    'settings.lunchRules': 'Lõuna reeglid',
    'settings.pauseAllowed': 'Paus lubatud',
    'settings.lunchAllowed': 'Lõuna lubatud',
    'settings.lunchMandatory': 'Lõuna kohustuslik',
    
    // Audit
    'audit.title': 'Auditilogi',
    'audit.subtitle': 'Jälgi kõiki süsteemi muudatusi ja tegevusi',
    'audit.filters': 'Filtrid',
    'audit.actionType': 'Tegevuse tüüp',
    'audit.targetType': 'Sihtmärgi tüüp',
    'audit.allActions': 'Kõik tegevused',
    'audit.allTargets': 'Kõik sihtmärgid',
    'audit.timestamp': 'Ajatempel',
    'audit.user': 'Kasutaja',
    'audit.action': 'Tegevus',
    'audit.target': 'Sihtmärk',
    'audit.details': 'Üksikasjad',
    'audit.noLogs': 'Auditi kirjeid ei leitud',
    'audit.userCreated': 'Kasutaja loodud',
    'audit.userUpdated': 'Kasutaja uuendatud',
    'audit.userDeleted': 'Kasutaja kustutatud',
    'audit.objectCreated': 'Objekt loodud',
    'audit.objectUpdated': 'Objekt uuendatud',
    'audit.objectDeleted': 'Objekt kustutatud',
    'audit.geofenceUpdated': 'Geopiir uuendatud',
    'audit.rulesUpdated': 'Reeglid uuendatud',
    'audit.monthClosed': 'Kuu suletud',
    'audit.monthReopened': 'Kuu avatud',
    'audit.roleChanged': 'Roll muudetud',
    'audit.absenceMarked': 'Puudumine märgitud',
    
    // Live View
    'live.title': 'Reaalajas',
    'live.subtitle': 'Töötajate staatuse jälgimine reaalajas',
    'live.selectObject': 'Vali objekt',
    'live.refresh': 'Värskenda',
    'live.working': 'Töötavad',
    'live.onPause': 'Pausil',
    'live.atLunch': 'Lõunal',
    'live.outside': 'Väljas',
    'live.noGps': 'GPS puudub',
    'live.violations': 'Rikkumised',
    'live.employeesAt': 'Töötajad objektil',
    'live.lastUpdated': 'Viimati uuendatud',
    'live.liveIndicator': 'Live',
    'live.noEmployees': 'Sellele objektile pole töötajaid määratud',
    
    // Month names
    'months.january': 'Jaanuar',
    'months.february': 'Veebruar',
    'months.march': 'Märts',
    'months.april': 'Aprill',
    'months.may': 'Mai',
    'months.june': 'Juuni',
    'months.july': 'Juuli',
    'months.august': 'August',
    'months.september': 'September',
    'months.october': 'Oktoober',
    'months.november': 'November',
    'months.december': 'Detsember',
    'months.closedAt': 'Suletud',
    'months.aboutTitle': 'Kuu sulgemise kohta',
    'months.aboutItem1': 'Kuu sulgemine muudab kõik selle kuu tööaja kirjed kirjutuskaitsuks',
    'months.aboutItem2': 'Töötajad ei saa uuendada oma staatust suletud kuu kuupäevadel',
    'months.aboutItem3': 'Ainult administraatorid saavad suletud kuud uuesti avada',
    'months.aboutItem4': 'Kõik sulgemise/avamise tegevused logitakse auditilogisse',
    'months.confirmReopen': 'Kas olete kindel, et soovite {month} {year} uuesti avada? See tegevus logitakse.',
    'months.closeSuccess': '{month} {year} edukalt suletud',
    'months.reopenSuccess': '{month} {year} edukalt avatud',
    'months.closeError': 'Kuu sulgemine ebaõnnestus',
    'months.reopenError': 'Kuu avamine ebaõnnestus',
    'months.loadError': 'Kuude staatuse laadimine ebaõnnestus',
    
    // Login page
    'login.presenceBased': 'Kohaloleku',
    'login.timeTracking': 'jälgimine',
    'login.heroDescription': 'Jälgi töötajate kohalolekut tööobjektidel täpselt. Ilma marsruutideta, ilma jälgimiseta — ainult faktid.',
    'login.accuracy': 'Täpsus',
    'login.monitoring': 'Jälgimine',
    'login.setup': 'Seadistus',
    'login.welcomeBack': 'Tere tulemast tagasi',
    'login.enterCredentials': 'Sisesta oma andmed jätkamiseks',
    'login.email': 'E-post',
    'login.password': 'Parool',
    'login.signIn': 'Logi sisse',
    'login.noAccount': 'Pole kontot?',
    'login.registerCompany': 'Registreeri ettevõte',
    'login.loginFailed': 'Sisselogimine ebaõnnestus. Proovi uuesti.',
    'login.demoHint': 'Demo',
    'login.forgotPassword': 'Unustasid parooli?',
    'acceptInvite.title': 'Määra parool',
    'acceptInvite.subtitle': 'Loo parool oma Work+ konto aktiveerimiseks',
    'acceptInvite.submit': 'Aktiveeri konto',
    'acceptInvite.invalidTitle': 'Link on aegunud või kehtetu',
    'acceptInvite.invalidBody': 'Palun võtke ühendust administraatoriga kutse uuesti saatmiseks.',
    'acceptInvite.doneTitle': 'Konto aktiveeritud!',
    'acceptInvite.doneBody': 'Suunatakse sisselogimislehele...',
    'acceptInvite.error': 'Midagi läks valesti. Proovi uuesti.',
    'employees.inviteSent': 'Kutse saadeti töötaja e-postile',
    'forgotPassword.title': 'Parooli taastamine',
    'forgotPassword.subtitle': 'Sisesta oma e-post ja saadame sulle lähtestamislingi',
    'forgotPassword.send': 'Saada link',
    'forgotPassword.sentTitle': 'Kontrolli oma e-posti',
    'forgotPassword.sentBody': 'Kui see e-post on registreeritud, saad varsti parooli lähtestamise lingi.',
    'forgotPassword.backToLogin': 'Tagasi sisselogimisele',
    'forgotPassword.error': 'Midagi läks valesti. Proovi uuesti.',
    'resetPassword.title': 'Uus parool',
    'resetPassword.submit': 'Määra uus parool',
    'resetPassword.invalidTitle': 'Link on aegunud või kehtetu',
    'resetPassword.invalidBody': 'Palun taotle uus parooli lähtestamise link.',
    'resetPassword.doneTitle': 'Parool muudetud!',
    'resetPassword.doneBody': 'Suunatakse sisselogimislehele...',
    'resetPassword.error': 'Midagi läks valesti. Proovi uuesti.',
    
    // Register page
    'register.joinToday': 'Liitu {appName}',
    'register.heroDescription': 'Alusta kohaloleku jälgimist oma tööobjektidel. Lihtne, läbipaistev ja tõhus.',
    'register.createAccount': 'Loo konto',
    'register.enterDetails': 'Sisesta oma andmed alustamiseks',
    'register.fullName': 'Täisnimi',
    'register.email': 'E-post',
    'register.password': 'Parool',
    'register.confirmPassword': 'Kinnita parool',
    'register.createAccountBtn': 'Loo konto',
    'register.haveAccount': 'On juba konto?',
    'register.signIn': 'Logi sisse',
    'register.passwordsNoMatch': 'Paroolid ei kattu',
    'register.passwordTooShort': 'Parool peab olema vähemalt 6 tähemärki',
    'register.registerFailed': 'Registreerimine ebaõnnestus. Proovi uuesti.',
    
    // Register Company page
    'registerCompany.title': 'Registreeri oma ettevõte',
    'registerCompany.freeTrial': '30 päeva tasuta',
    'registerCompany.companyData': 'Ettevõtte andmed',
    'registerCompany.companyName': 'Ettevõtte nimi',
    'registerCompany.companyNamePlaceholder': 'Ettevõtte nimi',
    'registerCompany.companyEmail': 'Ettevõtte e-post',
    'registerCompany.phone': 'Telefon',
    'registerCompany.phonePlaceholder': '+372 ...',
    'registerCompany.address': 'Aadress',
    'registerCompany.addressPlaceholder': 'Tallinn',
    'registerCompany.adminData': 'Administraatori andmed',
    'registerCompany.adminName': 'Teie nimi',
    'registerCompany.adminNamePlaceholder': 'Jaan Tamm',
    'registerCompany.adminEmail': 'Administraatori sisselogimise e-post',
    'registerCompany.sameAsCompany': 'Sama mis ettevõtte e-post',
    'registerCompany.password': 'Parool',
    'registerCompany.createAccount': 'Loo ettevõtte konto',
    'registerCompany.haveAccount': 'On juba konto?',
    'registerCompany.signIn': 'Logi sisse',
    'registerCompany.trialInfo': '30 päeva tasuta • kuni 10 töötajat • kõik funktsioonid',
    'registerCompany.registrationFailed': 'Registreerimine ebaõnnestus',
    'registerCompany.pwMin8': 'Vähemalt 8 tähemärki',
    'registerCompany.pwLetter': 'Vähemalt üks täht',
    'registerCompany.pwDigit': 'Vähemalt üks number',
    'registerCompany.pwInvalid': 'Parool peab olema vähemalt 8 tähemärki ning sisaldama tähte ja numbrit',
    'registerCompany.agreeTerms': 'Olen lugenud ja nõustun',
    'registerCompany.termsLink': 'Kasutustingimustega',
    'registerCompany.agreePrivacy': 'Olen lugenud ja nõustun',
    'registerCompany.privacyLink': 'Privaatsuspoliitikaga',
    'registerCompany.consentRequired': 'Jätkamiseks nõustuge kasutustingimuste ja privaatsuspoliitikaga',
  }
};

export default translations;
